import React, { useState, useEffect, useCallback, useMemo } from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
// import qs from 'querystring';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  ButtonBase,
  Box,
  useMediaQuery,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ExpandMore, ThumbUp, ThumbDown } from '@material-ui/icons';
// import { Alert } from '@material-ui/lab';
import { parse, isAfter, isValid } from 'date-fns';

import {
  isArray,
  assign,
  isEmpty,
  reduce,
  includes,
  isUndefined,
  isNull,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import {
  Form as FormUI,
  Autocomplete,
  Input,
  DateTime,
  Select,
  Hidden,
} from '~/components/Form';
import { ONLINE } from '~/constants/default';
import {
  CUSTOMIZACAO_RAIZEN,
  MODULONFE,
  SKID,
  MODULOFOTO,
} from '~/constants/modules';
import { t, number, can, removerMascaraCNPJ } from '~/helpers';
import api from '~/services/api';

import DeleteButtonWithModal from '../DeleteButtonWithModal';
import PesquisaTabelaInput from '../PesquisaTabelaInput';
import TabelaRecebimento from '../Table';
import TableBatch from '../TableBatch';
import TableCompartments from '../TableCompartments';
import {
  RECEBIMENTO_READ_ONLY,
  RECEBIMENTO_SELECT_TANKS,
  RECEBIMENTO_WAIT_FINISH,
} from './constantes';
import defaultInitial from './initialState';
import * as S from './styles';

const useStyles = makeStyles({
  table: {
    maxWidth: 650,
  },
});

const LIMITE_JUSTIFICATIVA_CAPACIDADE = 200;

const Form = React.forwardRef((props, ref) => {
  const { onCloseModal, formEdit } = props;

  const history = useHistory();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // 05-05-2025  novo para visualizar
  // console.log(JSON.stringify(props));
  const isFinalizado = Number(formEdit?.finalizadadescarganf) === 1;
  // console.log(JSON.stringify(isFinalizado));

  const token = useSelector((state) => state.auth);

  const initial = assign({}, defaultInitial);

  const classes = useStyles();
  const formRef = React.useRef(null);
  const confirmandoInicioRef = React.useRef(false);
  const tanquesInicioPendentesRef = React.useRef([]);

  const { client, id } = useSelector((state) => state.user.profile);

  const {
    controlanfeclienteconfig,
    permitirselecionarmaisdeumtanquenorecebimentoclienteconfig,
    permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig,
    permitirrecebimentosemumxmlnosistemaclienteconfig,
  } = useSelector((state) => state.user.configs);

  const [initials, setInitials] = useState({});
  const [receivement, setReceivement] = useState(2);
  const [open, setOpen] = useState(false);
  const [openConfirmaInicio, setOpenConfirmaInicio] = useState(false);
  const [openAlertaCapacidade, setOpenAlertaCapacidade] = useState(false);
  const [openAlertaDivergenciaEstoque, setOpenAlertaDivergenciaEstoque] =
    useState(false);
  const [tanquesDivergentesEstoque, setTanquesDivergentesEstoque] = useState(
    []
  );
  const [openJustificativaCapacidade, setOpenJustificativaCapacidade] =
    useState(false);
  const [justificativaCapacidade, setJustificativaCapacidade] = useState('');
  const [openConfirmaFim, setOpenConfirmaFim] = useState(false);
  const [volume, setVolume] = useState(Number(initial.volumenfdescarganf));
  const [price, setPrice] = useState(Number(initial.precounitariodescarganf));

  const [expanded, setExpanded] = useState('nf');

  const [tanques, setTanques] = useState([]);
  const [statusRecebimento, setStatusRecebimento] = useState(0);
  const [typeTank, setTypeTank] = useState(0); // 2
  const [diffTank, setDiffTank] = useState(0);
  const [loading, setLoading] = useState(false);
  const [resumoVolAbs, setResumoVolAbs] = useState(0);
  const [load, setLoad] = useState(false);

  const [habOper20, setHabOper20] = useState(false);

  const [habCompartments, setHabCompartments] = useState(false);
  const [
    habOperamostracompartimentossemreceb20,
    setOperamostracompartimentossemreceb20,
  ] = useState(false);

  const [habReceipt, setHabReceipt] = useState(false);
  const [
    habHabilitafotonotafiscalposto,
    setHabHabilitafotonotafiscalposto,
  ] = useState(false);
  const [
    habilitaInspesaoDescargaPosto,
    setHabilitaInspesaoDescargaPosto,
  ] = useState(false);

  const [statusHabilitaSkidPosto, setStatusHabilitaSkidPosto] = useState(false);

  const [calculodensidadeproduto, setCalculodensidadeproduto] = useState(0);
  const [volume20, setVolume20] = useState(
    Number(initial.volume20nftbdescarganf)
  );
  const [densidade20NF, setDensidade20NF] = useState(
    Number(initial.densidade20nftbdescarganf)
  );
  const [temperaturaNF, setTemperaturaNF] = useState(
    Number(initial.temperaturanftbdescarganf)
  );
  const [numberCompartments, setNumberCompartments] = useState(
    can(SKID) ? 1 : 0
  );
  const [compartimentos, setCompartimentos] = useState([]);

  const [inspecao, setInspecao] = useState({});

  const [
    densidadecalculadaamostra20,
    setDensidadecalculadaamostra20,
  ] = useState(0.0);

  const [densidadeamostra, setDensidadeamostra] = useState(0.0);
  const [temperaturaamostra, setTemperaturaamostra] = useState(0.0);

  // Alertar que tem que salvar!
  const [necessarioBtnSalvar, setNecessarioBtnSalvar] = useState(false);

  const [habilitaDtaCampoInicio, setHabilitaDtaCampoInicio] = useState(true);
  const [habilitaDtaCampoFim, setHabilitaDtaCampoFim] = useState(false);

  const [tokenUuidDescarganf, setTokenUuidDescarganf] = useState(
    initials.tokenuuiddescarganf
  );
  const [jatiroufotodescarganf, setJatiroufotodescarganf] = useState(
    initials.jatiroufotodescarganf
  );
  const [dataFotos, setDataFotos] = useState([]);

  const [iddescarganfgeral, setIddescarganfgeral] = useState(null);
  const [idpostogeral, setIdpostogeral] = useState(null);

  const [tokenws, setTokenWs] = useState(null);
  const [ws, setWs] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');

  /*
    'naoLeuNF',
    'leuUmaNF',
    'leuMaisDeUmaNF',
    'leuNFManual',
  */
  const [statusLeituraNF, setStatusLeituraNF] = useState('');

  const [cnpjPosto, setCnpjPosto] = useState('0'); // 2

  const [openAceitaSemNotaFiscal, setOpenAceitaSemNotaFiscal] = useState(false);
  const [leuNF, setLeuNF] = useState(false);

  const [desabilitaClearInputAtive, setDesabilitaClearInputAtive] = useState(
    false
  );

  // const [nfdescarganf, setNfdescarganf] = useState('');
  const [nfdescarganf, setNfdescarganf] = useState(initials.nfdescarganf);

  const [objNf, setObjNf] = useState({});

  const [idnfedescarganf, setIdnfedescarganf] = useState('');

  const [version, setVersion] = useState('version4'); // version6 ; version4

  const [leuIdnfedescarganf, setLeuIdnfedescarganf] = useState(false);

  // Total price
  const total = React.useMemo(() => Number(volume * price), [volume, price]);

  // Skid
  const [skid, setSkid] = useState(null);
  // Skid - dados dinamicos
  const [dataSkid, setDataSkid] = useState([]);
  const [volumeSkid, setVolumeSkid] = useState(0);
  const [volume20Skid, setVolume20Skid] = useState(0);
  const [temperaturaSkid, setTemperaturaSkid] = useState(0);
  const [densidadeSkid, setDensidadeSkid] = useState(0);

  // Skid - resultado
  const handleRequestResultadoSkidAPI = useCallback(
    async (iddescarganf, idposto, statusHabilitaSkidPosto) => {
      try {
        if (!statusHabilitaSkidPosto) {
          return;
        }

        const request = await api.get(
          `${process.env.REACT_APP_URL_REQUEST}descargasnfs/skid/resultado/${iddescarganf}/${idposto}`,
          {
            headers: {
              'Current-Route': window.location.pathname,
              Authorization: 'Bearer ' + `${api.defaults.headers.token}`,
              // Authorization: 'Bearer ' + `${token.token}`,
            },
          }
        );
        setSkid(request.data);
      } catch (error) {
        if (isArray(error)) error.map((err) => toast.error(t(err)));
        else toast.error(t(error));
      }
    },
    [statusHabilitaSkidPosto]
  );

  // useEffect(() => {
  //   let o = initials ? initials : formEdit;
  //   if (
  //     can(SKID) &&
  //     !isUndefined(o?.idposto) &&
  //     o?.idposto > 0 &&
  //     !isUndefined(o?.resultadoDescargaSkid?.iddescarganf)
  //   ) {
  //     handleRequestResultadoSkidAPI(
  //       o?.resultadoDescargaSkid?.iddescarganf,
  //       o?.idposto
  //     );
  //   }
  // }, []);

  // useEffect(() => {
  //   let o = initials ? initials : formEdit;
  //   if (
  //     can(SKID) &&
  //     !isUndefined(o?.idposto) &&
  //     o?.idposto > 0 &&
  //     !isUndefined(o?.iddescarganf)
  //   ) {
  //     handleRequestResultadoSkidAPI(o?.iddescarganf, o?.idposto);
  //   }
  // }, [initials, formEdit]);

  useEffect(() => {
    const o = initials || formEdit;

    if (!statusHabilitaSkidPosto) {
      return;
    }

    const timeOut = setInterval(() => {
      if (
        can(SKID) &&
        !isUndefined(o?.idposto) &&
        o?.idposto > 0 &&
        !isUndefined(o?.iddescarganf)
      ) {
        handleRequestResultadoSkidAPI(
          o?.iddescarganf,
          o?.idposto,
          statusHabilitaSkidPosto
        );
      }
    }, 15000);

    return () => clearInterval(timeOut);
  }, [initials, formEdit, statusHabilitaSkidPosto]);
  // }, [initials, formEdit, statusHabilitaSkidPosto]);

  // Skid = dinamico
  const handleRequestSkidAPI = useCallback(
    async (idpreset, idposto) => {
      if (idpreset && idposto && idposto > 0) {
        try {
          const request = await api.get(
            `${process.env.REACT_APP_URL_REQUEST}descargasnfs/sinotico/detalhe/${idpreset}/${idposto}/`,
            {
              headers: {
                'Current-Route': window.location.pathname,
                Authorization: 'Bearer ' + `${token.token}`,
              },
            }
          );
          setDataSkid(request.data);
        } catch (error) {
          if (isArray(error)) error.map((err) => toast.error(t(err)));
          else toast.error(t(error));
        }
      }
    },
    [initials]
  );

  useEffect(() => {
    if (
      dataSkid[0]?.listaPresetDados[0]?.listaDescargas[0]?.statusPreset == 4 ||
      dataSkid[0]?.listaPresetDados[0]?.listaDescargas[0]?.statusPreset == 5
    ) {
      // executando ou pausado
      setVolumeSkid(
        (dataSkid[0]?.listaPresetDados[0]?.listaDescargas[0]
          ?.volumeAmbienteDescarregado || 0) +
        skid.volumeambientedescarganfrealizado
      );
      setVolume20Skid(
        (dataSkid[0]?.listaPresetDados[0]?.listaDescargas[0]
          ?.volume20Descarregado || 0) + skid.volume20descarganfrealizado
      );
      setTemperaturaSkid(
        dataSkid[0]?.listaPresetDados[0]?.listaDescargas[0]
          ?.componentesCorrentes[0]?.temperatura || 0
      );
      setDensidadeSkid(
        dataSkid[0]?.listaPresetDados[0]?.listaDescargas[0]
          ?.componentesCorrentes[0]?.densidade || 0
      );
    } else {
      // parado
      if (skid?.volumeambientedescarganfrealizado) {
        setVolumeSkid(skid?.volumeambientedescarganfrealizado);
        setVolume20Skid(skid?.volume20descarganfrealizado);
        setTemperaturaSkid(skid?.temperaturadescarganfrealizado);
        setDensidadeSkid(skid?.densidade20descarganfrealizado);
      }
    }
  }, [dataSkid]);

  useEffect(() => {
    if (skid) {
      handleRequestSkidAPI(skid.idpreset, skid.idposto);
    }
  }, [skid]);

  useEffect(() => {
    const timeOut = setInterval(() => {
      if (skid) {
        handleRequestSkidAPI(skid.idpreset, skid.idposto);
      }
    }, 15000);

    return () => clearInterval(timeOut);
  }, [skid]);

  const appUrl = `${window.location.host}/fotonf?id=${initials?.tokenuuiddescarganf
    }&token=${JSON.stringify(token?.token).replace(/^["']|["']$/g, '')}`;

  const irParaFotoNF = () => {
    const id = `id=${initials?.tokenuuiddescarganf}&token=${JSON.stringify(
      token?.token
    ).replace(/^["']|["']$/g, '')}`;
    history.push(`/fotonflocal?${id}`);
  };

  const tanquesVolumeRec = React.useMemo(
    () =>
      reduce(
        tanques.map(
          (tanque) =>
            tanque.volumefinaldescarganftanque -
            tanque.volumeinicialdescarganftanque
        ),
        (sum, n) => sum + n,
        0
      ),
    [tanques]
  );

  const diffNFMed = React.useMemo(() => {
    const v = Number(initials.volumenfdescarganf || volume);
    return Math.abs(Number((tanquesVolumeRec + resumoVolAbs - v) / v) * 100);
  }, [tanquesVolumeRec, resumoVolAbs, initials.volumenfdescarganf, volume]);

  // Open Modal
  const openModal = React.useCallback(() => {
    setOpen(true);
  }, []);

  // Close Modal
  const closeModal = React.useCallback(() => {
    setOpen(false);
    setInitials({});
  }, []);

  const handleCallbackClose = React.useCallback(() => {
    onCloseModal();
  }, []);

  const handleOpenConfirmaInicio = React.useCallback(
    () => setOpenConfirmaInicio(true),
    []
  );

  const handleCloseConfirmaInicio = React.useCallback(
    () => setOpenConfirmaInicio(false),
    []
  );

  const handleConfirmaAlertaCapacidade = React.useCallback(() => {
    setOpenAlertaCapacidade(false);
    setOpenJustificativaCapacidade(true);
  }, []);

  const handleConfirmaAlertaDivergenciaEstoque = React.useCallback(() => {
    initials.divergeestoquecontabilinicio = true;
    setOpenAlertaDivergenciaEstoque(false);
    handleValidaCapturaInicio(tanquesInicioPendentesRef.current, true);
  }, [initials]);

  const handleFechaAlertaDivergenciaEstoque = React.useCallback(() => {
    setOpenAlertaDivergenciaEstoque(false);
    initials.divergeestoquecontabilinicio = false;
  }, [initials]);

  const handleFechaAlertaCapacidade = React.useCallback(
    () => setOpenAlertaCapacidade(false),
    []
  );

  const handleConfirmaJustificativaCapacidade = React.useCallback(() => {
    const observacao = justificativaCapacidade.trim();

    if (!observacao) {
      toast.error(t('s.geral.validacao.campoobrigatorio'));
      return;
    }

    if (observacao.length > LIMITE_JUSTIFICATIVA_CAPACIDADE) {
      toast.error('A justificativa deve ter no maximo 200 caracteres.');
      return;
    }

    initials.obsdescargaacimacapacidadedescarganf = observacao;
    setOpenJustificativaCapacidade(false);
    handleOpenConfirmaInicio();
  }, [initials, justificativaCapacidade]);

  const handleFechaJustificativaCapacidade = React.useCallback(() => {
    setOpenJustificativaCapacidade(false);
    setJustificativaCapacidade('');
  }, []);

  const handleOpenConfirmaFim = React.useCallback(
    () => setOpenConfirmaFim(true),
    []
  );

  const handleCloseConfirmaFim = React.useCallback(
    () => setOpenConfirmaFim(false),
    []
  );

  const handleAtualizaTanques = (dadosTanques) => {
    setTanques(Object.assign([], dadosTanques));
  };

  const atualizaStatusRecebimento = (values) => {
    let retorno = RECEBIMENTO_READ_ONLY; // indica que a tabela não pode ser editada nem atualizada
    const items = values || initials;

    if (
      items.datahoradescarganf !== null &&
      items.datacapturainiciodescarganf === null
    ) {
      // Indica que a tabela deve exibir o checkbox para que o usuário escolha os tanques e digite os valores iniciais
      retorno = RECEBIMENTO_SELECT_TANKS;
    }

    if (
      items.datacapturainiciodescarganf !== null &&
      items.datacapturafimdescarganf === null
    ) {
      // indica que o ínicio já foi capturado e que devem ser digitados os valores finais
      retorno = RECEBIMENTO_WAIT_FINISH;
    }

    setStatusRecebimento(retorno);
  };

  const handleAtualizaCompartimentos = (dadosCompartimentos) => {
    setCompartimentos(Object.assign([], dadosCompartimentos));
    if (expanded === 'compartments') {
      setNecessarioBtnSalvar(true);
    }
    setInitials((state) => ({
      ...state,
      compartimentos: dadosCompartimentos,
    }));
  };

  const handleTestVolume20 = useCallback((value) => {
    const regex1 = /^((\d+\,\d+){1})$/;
    const regex2 = /^(\d+)$/;
    const regex3 = /^((\d+\.\d+){1})$/;

    if (isEmpty(value)) {
      return false;
    }

    if (Number(value) <= 0) {
      return false;
    }

    if (
      regex1.test(value) ||
      regex2.test(value) ||
      regex3.test(value) ||
      isEmpty(value)
    ) {
      return true;
    }

    return false;
  }, []);

  const handleTestCompartimentoAmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo compartimentos amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo compartimentos amostra!`);
        return false;
      }
      if (Number(value) > numberCompartments) {
        toast.error(
          `Valor máxima permitido para campo compartimentos amostra ${numberCompartments}`
        );
        return false;
      }
      return true;
    },
    [numberCompartments, expanded]
  );

  const handleTestTemperaturaAmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo temperatura amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo temperatura amostra!`);
        return false;
      }
      if (Number(value) > 99) {
        toast.error(`Valor inválido para campo temperatura amostra!`);
        return false;
      }
      return true;
    },
    [expanded]
  );

  const handleTestDensidadeAmbienteAmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo densidade ambiente amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo densidade ambiente amostra!`);
        return false;
      }
      if (Number(value) > 99) {
        toast.error(`Valor inválido para campo densidade ambiente amostra!`);
        return false;
      }
      return true;
    },
    [expanded]
  );

  const handleTestDensidade20AmostraDescarganf = useCallback(
    (value) => {
      if (isEmpty(value)) {
        toast.error(`Valor inválido para campo densidade 20 amostra!`);
        return false;
      }
      if (Number(value) <= 0) {
        toast.error(`Valor inválido para campo densidade 20 amostra!`);
        return false;
      }
      if (Number(value) > 99) {
        toast.error(`Valor inválido para campo densidade 20 amostra!`);
        return false;
      }
      return true;
    },
    [expanded]
  );

  const getValidationCompartmentsSchema = (
    habCompartments,
    permitirMaisDeUm
  ) => {
    const maxCompartimentos = permitirMaisDeUm ? 16 : 1;

    return Yup.object().shape({
      numerocompartimentosdescarganf: habCompartments
        ? Yup.number()
          .typeError(t('s.geral.validacao.tiponumerico'))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
          .max(
            maxCompartimentos,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              maxCompartimentos
            )
          )
        : Yup.string().nullable(),
    });
  };

  // Schema Validade
  const schemaValidade = React.useMemo(
    () =>
      Yup.object().shape({
        idposto: Yup.string()
          .transform((value, originalValue) =>
            originalValue === '' || originalValue === null ? undefined : value
          )
          .required(t('s.geral.validacao.campoobrigatorio')),
        // idposto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        idproduto: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        cnpjdistribuidoradescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),
        cnpjtransportadoradescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),

        datahorainiciodescarganf: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),

        datahorafimdescarganf:
          typeTank === 1 && statusRecebimento !== RECEBIMENTO_WAIT_FINISH
            ? Yup.string()
            : habilitaDtaCampoFim === true
              ? Yup.string()
                .nullable()
                .required(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string(),
        numeropedidodescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            can(CUSTOMIZACAO_RAIZEN) ? 10 : 15,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              can(CUSTOMIZACAO_RAIZEN) ? 10 : 15
            )
          ),
        nfdescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            can(CUSTOMIZACAO_RAIZEN) ? 10 : 15,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              can(CUSTOMIZACAO_RAIZEN) ? 10 : 15
            )
          ),
        dataemissaonfdescarganf: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        placactdescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),
        motoristadescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        volumenfdescarganf: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        volumenfdescarganf: Yup.number()
          .transform((value, originalValue) =>
            originalValue === '' ? 0 : value
          )
          .nullable()
          .required(t('s.geral.validacao.campoobrigatorio')),
        volumenfdescarganf: Yup.number()
          .transform((value, originalValue) => {
            if (originalValue === '' || isNaN(originalValue)) {
              return undefined;
            }
            return Number(originalValue);
          })
          .nullable()
          .typeError('Digite um número válido')
          .required(t('s.geral.validacao.campoobrigatorio')),

        // volumenfdescarganf: Yup.number().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        precounitariodescarganf: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        tipodescarganf: can(CUSTOMIZACAO_RAIZEN)
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        numerocompartimentosdescarganf: habCompartments
          ? Yup.number()
            .typeError(t('s.geral.validacao.tiponumerico'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
            .max(
              permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig ===
                'S'
                ? 16
                : 1,
              t('s.geral.validacao.tamanhomaximo').replace(
                '%s',
                permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig ===
                  'S'
                  ? 16
                  : 1
              )
            )
          : Yup.string().nullable(),

        temperaturanftbdescarganf:
          habOper20 && Number(calculodensidadeproduto) >= 1
            ? // habReceipt && Number(calculodensidadeproduto) >= 1
            Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .transform((value) => (isNaN(value) ? undefined : value))
              .moreThan(
                -1,
                t('s.geral.validacao.valorminimo').replace('%s', 0)
              )
              .lessThan(
                101,
                t('s.geral.validacao.valormaximo').replace('%s', 100)
              )
            : Yup.string().nullable(),
        densidade20nftbdescarganf:
          habOper20 && Number(calculodensidadeproduto) >= 1
            ? // habReceipt && Number(calculodensidadeproduto) >= 1
            Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .transform((value) => (isNaN(value) ? undefined : value))
              .moreThan(
                -1,
                t('s.geral.validacao.valorminimo').replace('%s', 0)
              )
              .lessThan(
                2,
                t('s.geral.validacao.valormaximo').replace('%s', 2)
              )
            : Yup.string().nullable(),
        volume20nftbdescarganf:
          habOper20 && Number(calculodensidadeproduto) >= 1
            ? // habReceipt && Number(calculodensidadeproduto) >= 1
            Yup.string()
              .test('Valor Inválido', 'Valor Inválido', (value) =>
                handleTestVolume20(value)
              )
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        compartimentoamostradescarganf:
          receivement === 1 &&
            habReceipt &&
            habCompartments &&
            Number(calculodensidadeproduto) >= 1
            ? Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .test('Valor Inválido', 'Valor Inválido', (value) =>
                handleTestCompartimentoAmostraDescarganf(value)
              )
            : Yup.string().nullable(),
        temperaturaamostratbdescarganf:
          receivement === 1 &&
            habReceipt &&
            habCompartments &&
            Number(calculodensidadeproduto) >= 1
            ? Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .test('Valor Inválido', 'Valor Inválido', (value) =>
                handleTestTemperaturaAmostraDescarganf(value)
              )
            : Yup.string().nullable(),
        densidadeambienteamostratbdescarganf:
          receivement === 1 &&
            habReceipt &&
            habCompartments &&
            Number(calculodensidadeproduto) >= 1
            ? Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .test('Valor Inválido', 'Valor Inválido', (value) =>
                handleTestDensidadeAmbienteAmostraDescarganf(value)
              )
            : Yup.string().nullable(),

        inspecao: Yup.object().shape({
          inpsdataentradabdescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),

          inpsdatasaidabdescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .test(
                  'data-fim-maior',
                  t('s.geral.validacao.datamaiorentrada'), // Ex: "A data de saída deve ser maior que a data de entrada"
                  function (value) {
                    const entradaStr = this.parent
                      .inpsdataentradabdescarganfinspecao;

                    if (!entradaStr || !value) return true;

                    const entrada = parse(
                      entradaStr,
                      'dd/MM/yyyy HH:mm:ss',
                      new Date()
                    );
                    const saida = parse(
                      value,
                      'dd/MM/yyyy HH:mm:ss',
                      new Date()
                    );

                    if (!isValid(entrada) || !isValid(saida)) return false;

                    return isAfter(saida, entrada);
                  }
                )
              : Yup.string().nullable(),

          inpslacresconferemdescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inspprodutosetadescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpsisentoaguaimpurezadescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpsvisualprodutodescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpscompartimentovaziodescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),

          inpslacresnumerodescarganfinspecao: Yup.string()
            .nullable()
            .test(
              'campo-obrigatorio-se-S',
              t('s.geral.validacao.campoobrigatorio'),
              function (value) {
                const { inpslacresconferemdescarganfinspecao } = this.parent;

                const precisaValidar =
                  receivement === 1 &&
                  habilitaInspesaoDescargaPosto &&
                  inpslacresconferemdescarganfinspecao === 'S';

                if (!precisaValidar) return true; // não valida
                return !!value; // precisa ter valor
              }
            )
            .typeError(t('s.geral.validacao.campoobrigatorio')),

          // inpslacresnumerodescarganfinspecao: Yup.string()
          //   .when('inpslacresconferemdescarganfinspecao', {
          //     is: 'S',
          //     then: (schema) =>
          //       receivement === 1 && habilitaInspesaoDescargaPosto
          //         ? schema
          //           .required(t('s.geral.validacao.campoobrigatorio'))
          //           .typeError(t('s.geral.validacao.campoobrigatorio'))
          //         : schema.nullable(),
          //     otherwise: (schema) => schema.nullable(),
          //   }),

          // inpslacresnumerodescarganfinspecao:
          //   receivement === 1 && habilitaInspesaoDescargaPosto
          //     ? Yup.string()
          //         .required(t('s.geral.validacao.campoobrigatorio'))
          //         .typeError(t('s.geral.validacao.campoobrigatorio'))
          //     : Yup.string().nullable(),
        }),

        densidade20amostradescarganf:
          receivement === 1 &&
            habReceipt &&
            habCompartments &&
            Number(calculodensidadeproduto) >= 1
            ? Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .test('Valor Inválido', 'Valor Inválido', (value) =>
                handleTestDensidade20AmostraDescarganf(value)
              )
            : Yup.string().nullable(),
      }),
    [
      typeTank,
      statusRecebimento,
      RECEBIMENTO_WAIT_FINISH,
      habilitaDtaCampoFim,
      habCompartments,
      habilitaInspesaoDescargaPosto,
      calculodensidadeproduto,
      habReceipt,
      numberCompartments,
      nfdescarganf,
      permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig,
      habOper20,
    ]
  );

  const schemaValidadeFim = React.useMemo(
    () =>
      Yup.object().shape({
        idposto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        idproduto: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        cnpjdistribuidoradescarganf: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        //   .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),
        cnpjtransportadoradescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),

        numeropedidodescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            can(CUSTOMIZACAO_RAIZEN) ? 10 : 15,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              can(CUSTOMIZACAO_RAIZEN) ? 10 : 15
            )
          ),
        nfdescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            can(CUSTOMIZACAO_RAIZEN) ? 10 : 15,
            t('s.geral.validacao.tamanhomaximo').replace(
              '%s',
              can(CUSTOMIZACAO_RAIZEN) ? 10 : 15
            )
          ),
        dataemissaonfdescarganf: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        placactdescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),
        motoristadescarganf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        volumenfdescarganf: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        precounitariodescarganf: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio')),

        inspecao: Yup.object().shape({
          inpsdataentradabdescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpsdatasaidabdescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .test(
                  'data-fim-maior',
                  t('s.geral.validacao.datamaiorentrada9999'), // Ex: "A data de saída deve ser maior que a data de entrada"
                  function (value) {
                    const entradaStr = this.parent
                      .inpsdataentradabdescarganfinspecao;

                    if (!entradaStr || !value) return true;

                    const entrada = parse(
                      entradaStr,
                      'dd/MM/yyyy HH:mm:ss',
                      new Date()
                    );
                    const saida = parse(
                      value,
                      'dd/MM/yyyy HH:mm:ss',
                      new Date()
                    );

                    if (!isValid(entrada) || !isValid(saida)) return false;

                    return isAfter(saida, entrada);
                  }
                )
              : Yup.string().nullable(),

          // inpsdatasaidabdescarganfinspecao: receivement === 1 && habilitaInspesaoDescargaPosto
          //   ? Yup.string()
          //     .required(t('s.geral.validacao.campoobrigatorio'))
          //     .typeError(t('s.geral.validacao.campoobrigatorio'))
          //     .test(
          //       'data-fim-maior',
          //       t('s.geral.validacao.datamaiorentrada'), // Ex: "A data de saída deve ser maior que a data de entrada"
          //       function (value) {
          //         const { inpsdataentradabdescarganfinspecao } = this.parent;
          //         if (!inpsdataentradabdescarganfinspecao || !value) return true;
          //         const entrada = new Date(inpsdataentradabdescarganfinspecao);
          //         const saida = new Date(value);
          //         return saida > entrada;
          //       }
          //     )
          //   : Yup.string().nullable(),

          // inpsdatasaidabdescarganfinspecao:
          //   receivement === 1 &&
          //     habilitaInspesaoDescargaPosto
          //     ? Yup.string()
          //       .required(t('s.geral.validacao.campoobrigatorio'))
          //       .typeError(t('s.geral.validacao.campoobrigatorio'))
          //     : Yup.string().nullable(),
          inpslacresconferemdescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inspprodutosetadescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpsisentoaguaimpurezadescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpsvisualprodutodescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),
          inpscompartimentovaziodescarganfinspecao:
            receivement === 1 && habilitaInspesaoDescargaPosto
              ? Yup.string()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
              : Yup.string().nullable(),

          inpslacresnumerodescarganfinspecao: Yup.string()
            .nullable()
            .max(249, t('s.geral.validacao.tamanhomaximo').replace('%s', 249))
            .test(
              'campo-obrigatorio-se-S',
              t('s.geral.validacao.campoobrigatorio'),
              function (value) {
                const { inpslacresconferemdescarganfinspecao } = this.parent;

                const precisaValidar =
                  receivement === 1 &&
                  habilitaInspesaoDescargaPosto &&
                  inpslacresconferemdescarganfinspecao === 'S';

                if (!precisaValidar) return true; // não valida
                return !!value; // precisa ter valor
              }
            )
            .typeError(t('s.geral.validacao.campoobrigatorio')),
        }),

        tipodescarganf: can(CUSTOMIZACAO_RAIZEN)
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
      }),
    [
      typeTank,
      statusRecebimento,
      RECEBIMENTO_WAIT_FINISH,
      habilitaDtaCampoFim,
      habilitaInspesaoDescargaPosto,
    ]
  );

  // Busca dados do volume abastecido
  const handleGetSummaryVL = React.useCallback(async (nf, tank) => {
    try {
      setLoad(true);
      const response = await api.get(`descargasnfs/volumesaida/${nf}/${tank}`);
      setResumoVolAbs(response.data.volumesaidadescarganftanque);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  // Submit form
  const handleSubmit = React.useCallback(
    async (data) => {
      try {
        if (
          data.datahorainiciodescarganf === undefined ||
          data.datahorainiciodescarganf === null ||
          data.datahorainiciodescarganf === ''
        ) {
          data.datahorainiciodescarganf =
            initials.datahorainiciodescarganf !== null
              ? initials.datahorainiciodescarganf
              : '';
        }

        if (
          data.datahorafimdescarganf === undefined ||
          data.datahorafimdescarganf === null ||
          data.datahorafimdescarganf === ''
        ) {
          data.datahorafimdescarganf =
            initials.datahorafimdescarganf !== null
              ? initials.datahorafimdescarganf
              : '';
        }

        if (
          data.nfdescarganf === undefined ||
          data.nfdescarganf === null ||
          data.nfdescarganf === ''
        ) {
          data.nfdescarganf =
            initials.nfdescarganf !== null
              ? initials.nfdescarganf
              : nfdescarganf;
        }

        // console.log(JSON.stringify(data));

        await schemaValidade.validate(data, {
          abortEarly: false,
        });

        // const schema = getValidationCompartmentsSchema(habCompartments, permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig);
        // await schema.validate(data, { abortEarly: false });

        data.precototaldescarganf = total;
        data.idcliente = client;
        data.idusuario = id;
        data.precounitariodescarganf = Number(data.precounitariodescarganf);
        data.volumenfdescarganf = Number(data.volumenfdescarganf);
        data.tipodescarganf = data.tipodescarganf ?? null;

        data.comnfedescarganf = statusLeituraNF === 'leuUmaNF' ? 'S' : 'N';

        const modifyData = assign(initials, data);

        if (Number(data.tipodescargaposto) === 2) {
          delete modifyData.tipodescargaposto;

          try {
            setLoad(true);
            await api.post('descargasnfs', modifyData);

            toast.success(t('s.operacao.recebimentonf.recebimentorealizado'));

            setInitials({});
            closeModal();
          } catch (err) {
            const message =
              err?.response?.data?.message ||
              err?.response?.data?.error ||
              err?.response?.data ||
              err?.message ||
              err;

            if (isArray(message)) {
              message.forEach((e) => toast.error(t(e)));
            } else {
              toast.error(t(message));
            }
          } finally {
            setLoad(false);
          }
        } else {
          delete modifyData.tipodescargaposto;

          try {
            setLoad(true);
            const response = await api.put('descargasnfs/salva', modifyData);
            toast.success(t('s.operacao.recebimentonf.dadosnfsalvo'));

            setIddescarganfgeral(response.data.iddescarganf);
            setIdpostogeral(response.data.idposto);
            setTokenUuidDescarganf(response.data.tokenuuiddescarganf);
            setTokenWs(response.data.tokenuuiddescarganf);
            // console.log(JSON.stringify(response));

            setReceivement(Number(data.tipodescargaposto || receivement));
            setInitials(assign(initials, response.data));
            setExpanded('tank');

            if (isEmpty(tanques)) {
              setTanques(initials.tanques);
            }

            if (isEmpty(compartimentos)) {
              setCompartimentos(initials.compartimentos);
            }

            if (isEmpty(inspecao)) {
              setInspecao(initials.inspecao);
            }

            atualizaStatusRecebimento();
          } catch (err) {
            if (isArray(err)) err.map((e) => toast.error(t(e)));
            else toast.error(t(err));
          } finally {
            setLoad(false);
          }
        }

        if (!isEmpty(initials) && initials.finalizadadescarganf === 1) {
          closeModal();
        }
      } catch (err) {
        // console.log(JSON.stringify(err))

        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);

          if (validationErrors.hasOwnProperty('datahorafimdescarganf')) {
            setExpanded('nf');
          } else if (
            validationErrors.hasOwnProperty(
              'inspecao.inpsdatasaidabdescarganfinspecao'
            )
          ) {
            setExpanded('Inspection');
          }
          // setExpanded('nf');
        }
      }
    },
    [
      receivement,
      initials,
      typeTank,
      statusRecebimento,
      RECEBIMENTO_WAIT_FINISH,
      tanques,
      habilitaDtaCampoFim,
      statusLeituraNF,
      nfdescarganf,
      inspecao,
    ]
  );

  // Change Accordion
  const handleChangeAccordion = React.useCallback(
    (value) => {
      if (receivement !== 2) setExpanded(value === expanded ? null : value);
    },
    [expanded, receivement]
  );

  const handleValidaCapturaInicio = React.useCallback(async (tanques, validarCapacidade) => {
    let enviaDados = true;
    let tanqueselecionado = false;
    for (let idx = 0; idx < tanques.length; idx++) {
      if (tanques[idx].tanqueselecionado === 1) {
        tanqueselecionado = 1;
      }
      if (
        tanques[idx].valordigitado === 0 &&
        tanques[idx].tanqueselecionado === 1 &&
        tanques[idx].statussondatanquefisico !== ONLINE
      ) {
        enviaDados = false;
        toast.error(
          t('s.operacao.recebimentonf.digitealtura').replace(
            '%s',
            tanques[idx].codigotanquefisico
          )
        );
      }
    }
    if (!tanqueselecionado) {
      toast.error(t('s.operacao.recebimentonf.umtanquedeveserselecionado'));
    } else if (enviaDados) {
      try {
        tanquesInicioPendentesRef.current = tanques;
        const dadosFormulario = formRef.current
          ? formRef.current.getData()
          : {};
        const volumeNF = Number(dadosFormulario.volumenfdescarganf);
        const dadosValidacaoCapacidade = {
          ...initials,
          volumenfdescarganf: Number.isFinite(volumeNF)
            ? volumeNF
            : initials.volumenfdescarganf,
          tanques: tanques.filter(
            (tanque) => tanque.tanqueselecionado === 1
          ),
        };
        if (!validarCapacidade) {
          const divergenciasResponse = await api.put(
            'descargasnfs/validadivergenciaestoqueinicio',
            dadosValidacaoCapacidade
          );
          const tanquesDivergentes = divergenciasResponse.data || [];

          if (tanquesDivergentes.length > 0) {
            setTanquesDivergentesEstoque(tanquesDivergentes);
            setOpenAlertaDivergenciaEstoque(true);
            return;
          }

          initials.divergeestoquecontabilinicio = false;
        }
        const response = await api.put(
          'descargasnfs/validacapacidadeinicio',
          dadosValidacaoCapacidade
        );
        const excedeCapacidade =
          response.data === true || response.data === 'true';
        initials.excedecapacidadeinicio = excedeCapacidade;

        if (excedeCapacidade) {
          setJustificativaCapacidade('');
          setOpenAlertaCapacidade(true);
        } else if (initials.divergeestoquecontabilinicio) {
          setJustificativaCapacidade('');
          setOpenJustificativaCapacidade(true);
        } else {
          handleOpenConfirmaInicio();
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    }
  }, [initials]);

  const handleValidaCapturaFim = React.useCallback(
    async (tanques) => {
      try {
        const allData = formRef.current.getData();

        if (
          allData.datahorainiciodescarganf === undefined ||
          allData.datahorainiciodescarganf === null ||
          allData.datahorainiciodescarganf === ''
        ) {
          allData.datahorainiciodescarganf =
            initials.datahorainiciodescarganf !== null
              ? initials.datahorainiciodescarganf
              : '';
        }

        if (
          allData.datahorafimdescarganf === undefined ||
          allData.datahorafimdescarganf === null ||
          allData.datahorafimdescarganf === ''
        ) {
          allData.datahorafimdescarganf =
            initials.datahorafimdescarganf !== null
              ? initials.datahorafimdescarganf
              : '';
        }

        if (habilitaDtaCampoFim === true) {
          await schemaValidade.validate(allData, {
            abortEarly: false,
          });
        } else {
          await schemaValidadeFim.validate(allData, {
            abortEarly: false,
          });
        }

        let enviaDadosCompartErro = true;
        if (
          habCompartments &&
          Number(calculodensidadeproduto) >= 1 &&
          habOper20
        ) {
          const { compartimentos } = initials;
          for (let idx = 0; idx < compartimentos.length; idx++) {
            if (
              compartimentos[idx].volume20descarganfcompartimento === 0 ||
              compartimentos[idx].volume20descarganfcompartimento === NaN
            ) {
              enviaDadosCompartErro = false;
              toast.error(
                `Volume 20 do compartimento ${compartimentos[idx].compartimentodescarganfcompartimento} com erro!`
              );
            }
          }
        }

        let enviaDadosBateladaErro = true;
        if (habReceipt && Number(calculodensidadeproduto) >= 1 && habOper20) {
          const { tanques } = initials;
          for (let idxx = 0; idxx < tanques.length; idxx++) {
            if (
              tanques[idxx].densidadebateladafimdescarganftanque === 0 ||
              tanques[idxx].densidadebateladafimdescarganftanque === NaN
            ) {
              enviaDadosBateladaErro = false;
              toast.error(
                `Densidade 20 da batela ${tanques[idxx].codigotanquefisico} com erro!`
              );
            }
          }
        }

        let enviaDados = true;
        let soma = 0;

        for (let idxxx = 0; idxxx < tanques.length; idxxx++) {
          const volFinal = tanques[idxxx].volumefinaldescarganftanque;
          const volInc = tanques[idxxx].volumeinicialdescarganftanque;

          soma += volFinal - volInc;

          if (
            tanques[idxxx].valordigitado === 0 &&
            tanques[idxxx].statussondatanquefisico !== ONLINE
          ) {
            enviaDados = false;
            toast.error(
              t('s.operacao.recebimentonf.digitealtura').replace(
                '%s',
                tanques[idxxx].codigotanquefisico
              )
            );
          }
        }

        if (
          habCompartments &&
          Number(calculodensidadeproduto) >= 1 &&
          habOper20
        ) {
          if (enviaDados && enviaDadosCompartErro && enviaDadosBateladaErro) {
            handleOpenConfirmaFim(soma);
          }
        }
        if (Number(calculodensidadeproduto) >= 1 && habOper20) {
          if (enviaDados && enviaDadosBateladaErro) {
            handleOpenConfirmaFim(soma);
          }
        } else if (enviaDados) {
          handleOpenConfirmaFim(soma);
        }

        setDiffTank(soma);
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);

          setExpanded('nf');
        }
      }
    },
    [habilitaDtaCampoFim, initials]
  );

  const handleConfirmaInicio = React.useCallback(async () => {
    if (confirmandoInicioRef.current) return;

    confirmandoInicioRef.current = true;
    try {
      setLoad(true);
      initials.tanques = tanques;

      if (
        habCompartments &&
        Number(calculodensidadeproduto) >= 1 &&
        habOper20
      ) {
        const allData = formRef.current.getData();
        initials.densidade20amostradescarganf = Number(
          allData.densidade20amostradescarganf
        );
        initials.densidade20nftbdescarganf = Number(
          allData.densidade20nftbdescarganf
        );
        initials.temperaturanftbdescarganf = Number(
          allData.temperaturanftbdescarganf
        );
      }
      // console.log(JSON.stringify({ allData, initials }, null, 2))
      const response = await api.put('descargasnfs/confirmainicio', initials);
      toast.success(t('s.operacao.recebimentonf.iniciorecebimento'));

      setInitials(assign(initials, response.data));

      formRef.current.setFieldValue(
        'datahorainiciodescarganf',
        response.data.datahorainiciodescarganf
      );

      formRef.current.setFieldValue('nfdescarganf', response.data.nfdescarganf);

      setExpanded('tank');
      setTanques(initials.tanques);

      setCompartimentos(initials.compartimentos);

      // -- novo 27022025
      setTokenUuidDescarganf(initials.tokenuuiddescarganf);

      setJatiroufotodescarganf(initials.jatiroufotodescarganf);

      atualizaStatusRecebimento();
      handleCloseConfirmaInicio();
      // handleGetAllTanks();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      confirmandoInicioRef.current = false;
      setLoad(false);
    }
  }, [
    initials,
    tanques,
    habOper20,
    habCompartments,
    habilitaInspesaoDescargaPosto,
    calculodensidadeproduto,
  ]);
  // });

  const handleConfirmaFim = React.useCallback(async () => {
    try {
      setLoad(true);

      if (
        habCompartments &&
        Number(calculodensidadeproduto) >= 1 &&
        habOper20
      ) {
        const allData = formRef.current.getData();

        initials.densidade20amostradescarganf = Number(
          allData.densidade20amostradescarganf
        );
        initials.densidade20nftbdescarganf = Number(
          allData.densidade20nftbdescarganf
        );
        initials.temperaturanftbdescarganf = Number(
          allData.temperaturanftbdescarganf
        );
        // console.log(JSON.stringify({ allData, initials }, null, 2))
      }

      initials.tanques = tanques;

      const response = await api.put('descargasnfs/confirmafim', initials);
      toast.success(t('s.operacao.recebimentonf.recebimentofinalizado'));
      setInitials({});
      handleCloseConfirmaFim();
      closeModal();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, [
    initials,
    tanques,
    habCompartments,
    calculodensidadeproduto,
    habilitaInspesaoDescargaPosto,
  ]);
  // });

  const handleGetDadosFotos = useCallback(async (iddescarganf, idposto) => {
    try {
      const response = await api.get(
        `descargasnfs/fotos/${iddescarganf}/${idposto}`
      );
      setDataFotos(response.data);
    } catch (err) {
      setDataFotos([]);
      err.map((e) => toast.error(e));
    } finally {
    }
  }, []);

  const handleDeleteFotos = useCallback(async (iddescarganf, idposto) => {
    try {
      setLoading(true);
      const response = await api.delete(
        `descargasnfs/fotos/${iddescarganf}/${idposto}`
      );

      if (
        response?.status === 200 ||
        response?.status === 201 ||
        response?.status === 202
      ) {
        setJatiroufotodescarganf(true);
      } else {
        toast.error(response?.data);
      }
      // console.log(JSON.stringify(response));

      // handleCallbackClose();
    } catch (err) {
      err.map((e) => toast.error(e));
    } finally {
      setLoading(false);
    }
  }, []);

  // Load form edit
  const handleGetEditForm = React.useCallback(
    async (descarga, produto) => {
      setLoading(true);

      // console.log('handleGetEditForm');
      try {
        setLoad(true);

        const retorno = await api.get(`descargasnfs/${descarga}/${produto}`);

        const data = retorno?.data;

        // const { data } = await api.get(`descargasnfs/${descarga}/${produto}`);
        setInitials(data);

        setVolume20(data.volume20nftbdescarganf);

        setVolume(data.volumenfdescarganf);

        // console.log(JSON.stringify(data?.inspecao));

        // calculodensidadeproduto

        setTokenWs(data.tokenuuiddescarganf);

        if (!isEmpty(data.tanques)) {
          await setReceivement(1);
          await setTanques(data.tanques);

          setResumoVolAbs(
            (data.tanques || []).reduce(
              (total, tanque) =>
                total + Number(tanque.volumesaidadescarganftanque || 0),
              0
            )
          );
        }

        if (!isEmpty(data.compartimentos)) {
          await setCompartimentos(data.compartimentos);
        }

        if (!isEmpty(data.inspecao)) {
          await setInspecao(data.inspecao);
        }

        setNfdescarganf(data.nfdescarganf);

        setTokenUuidDescarganf(data.tokenuuiddescarganf);
        setJatiroufotodescarganf(data.jatiroufotodescarganf);

        setDensidadecalculadaamostra20(data.densidade20amostradescarganf);

        await atualizaStatusRecebimento(data);

        if (can(MODULONFE) && controlanfeclienteconfig === 'S') {
          const isMobileLocal = window.innerWidth <= 600;
          if (isMobileLocal) {
            setExpanded('photo');
          }
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
        setLoad(false);
      }
    },
    [controlanfeclienteconfig]
  );

  // Export functions
  React.useImperativeHandle(ref, () => ({
    openModal,
  }));

  React.useEffect(() => {
    let isOnline = false;
    if (receivement === 1 && statusRecebimento === RECEBIMENTO_WAIT_FINISH) {
      tanques.map((tanque) => {
        if (tanque.statussondatanquefisico === 1) {
          isOnline = true;
        }
      });

      if (isOnline) {
        setHabilitaDtaCampoInicio(false);
        setHabilitaDtaCampoFim(false);
      } else {
        setHabilitaDtaCampoInicio(true);
        setHabilitaDtaCampoFim(true);
      }
    } else {
      let temSelecionado = false;
      tanques.map((tanque) => {
        if (tanque.tanqueselecionado === 1) {
          temSelecionado = true;
          if (tanque.statussondatanquefisico === 1) {
            isOnline = true;
          }
        }
      });

      if (!temSelecionado) {
        setHabilitaDtaCampoInicio(true);
        setHabilitaDtaCampoFim(true);
      } else if (isOnline) {
        setHabilitaDtaCampoInicio(false);
        setHabilitaDtaCampoFim(false);
      } else {
        setHabilitaDtaCampoInicio(true);
        setHabilitaDtaCampoFim(true);
      }
    }
  }, [tanques]);

  React.useEffect(() => {
    if (!isEmpty(formEdit)) {
      const { iddescarganf, idposto } = formEdit;
      setIddescarganfgeral(iddescarganf);
      setIdpostogeral(idposto);
      handleGetEditForm(iddescarganf, idposto);
      if (can(MODULOFOTO)) {
        handleGetDadosFotos(iddescarganf, idposto);
      }
    }
  }, [formEdit, MODULOFOTO]);

  React.useEffect(() => {
    setInitials({
      iddescarganf: 0,
      idcliente: 0,
      idposto: 0,
      idproduto: 0,
      cnpjdistribuidoradescarganf: '',
      cnpjtransportadoradescarganf: '',
      idusuario: 0,
      datahoradescarganf: null,
      datahorainiciodescarganf: null,
      datahorafimdescarganf: null,
      datadadosnfdescarganf: null,
      datacapturainiciodescarganf: null,
      datacapturafimdescarganf: null,
      numeropedidodescarganf: '',
      nfdescarganf: '',
      dataemissaonfdescarganf: null,
      placactdescarganf: '',
      motoristadescarganf: '',
      volumenfdescarganf: 0.0,
      precounitariodescarganf: 0.0,
      precototaldescarganf: 0.0,
      temperaturaamostratbdescarganf: 0.0,
      densidadeambienteamostratbdescarganf: 0.0,
      densidade20tbdescarganf: 0.0,
      temperaturanftbdescarganf: 0.0,
      densidade20nftbdescarganf: 0.0,
      volume20nftbdescarganf: 0.0,
      finalizadadescarganf: 0,
      compartimentos: [],
      tanques: [],
      inspecao: {},

      comnfedescarganf: 'N',
    });
  }, []);

  const compartimentosVolume20Rec = React.useMemo(
    () =>
      reduce(
        compartimentos.map(
          (compartimento) => compartimento.volume20descarganfcompartimento
        ),
        (sum, n) => sum + n,
        0
      ),
    [compartimentos]
  );

  const compartimentosVolumeRec = React.useMemo(
    () =>
      reduce(
        compartimentos.map(
          (compartimento) =>
            compartimento.volumedeclaradodescarganfcompartimento
        ),
        (sum, n) => sum + n,
        0
      ),
    [compartimentos]
  );

  // Calcula a densidade da amostra
  const handleGetConverteDensidadePara20Graus = React.useCallback(async () => {
    if (
      densidadeamostra > 0 &&
      temperaturaamostra > 0 &&
      calculodensidadeproduto > 0
    ) {
      try {
        const response = await api.get(
          `/calculodensidades/converteDensidadePara20Graus/${densidadeamostra}/${temperaturaamostra}/${calculodensidadeproduto}`
        );
        formRef.current.setFieldValue(
          'densidade20amostradescarganf',
          response.data.densidade20
        );
        setDensidadecalculadaamostra20(response.data.densidade20);
        if (
          !response.data.temperaturaAmbienteValida ||
          !response.data.densidade20Valida ||
          !response.data.densidadeAmbienteValida
        ) {
          const validationErrors = {
            densidadeambienteamostratbdescarganf:
              response.data.msgErroDensidadeAmbiente,
            temperaturaamostratbdescarganf:
              response.data.msgErroTemperaturaAmbiente,
            densidade20amostradescarganf:
              response.data.densidade20 === 0
                ? 'Não é uma densidade válida!'
                : '',
          };
          if (formRef) {
            if (formRef.current) {
              formRef.current.setErrors(validationErrors);
            }
          }
        } else if (formRef) {
          if (formRef.current) {
            formRef.current.setErrors({});
          }
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
      }
    } else {
      setDensidadecalculadaamostra20(0);
    }
  }, [
    temperaturaamostra,
    densidadeamostra,
    calculodensidadeproduto,
    compartimentosVolumeRec,
    compartimentosVolume20Rec,
    volume,
  ]);

  // Calcula a volume 20 compartimento
  const handleGetVolumeNFPara20Graus = React.useCallback(
    async (
      densidadeamostra20,
      temperaturaamostra,
      volumeambiente,
      calculodensidadeproduto
    ) => {
      if (
        densidadeamostra20 > 0 &&
        temperaturaamostra > 0 &&
        volumeambiente > 0 &&
        calculodensidadeproduto > 0
      ) {
        try {
          const { data } = await api.get(
            `/calculodensidades/converteVolumePara20Graus/${densidadeamostra20}/${temperaturaamostra}/${volumeambiente}/${calculodensidadeproduto}`
          );

          const valor = Number(data.volume20).toFixed(1);

          const {
            densidade20Valida,
            densidadeAmbienteValida,
            temperaturaAmbienteValida,
            msgErroDensidadeAmbiente,
            msgErroTemperaturaAmbiente,
          } = data;

          if (
            String(msgErroDensidadeAmbiente).length > 0 &&
            String(msgErroTemperaturaAmbiente).length > 0
          ) {
            const validationErrorsErroDensidadeAmbiente = {
              densidade20nftbdescarganf: msgErroDensidadeAmbiente,
              temperaturanftbdescarganf: msgErroTemperaturaAmbiente,
            };
            if (formRef) {
              if (formRef.current) {
                formRef.current.setErrors(
                  validationErrorsErroDensidadeAmbiente
                );
              }
            }
          } else {
            if (String(msgErroDensidadeAmbiente).length > 0) {
              const validationErrorsErroDensidadeAmbiente = {
                densidade20nftbdescarganf: msgErroDensidadeAmbiente,
              };
              if (formRef) {
                if (formRef.current) {
                  formRef.current.setErrors(
                    validationErrorsErroDensidadeAmbiente
                  );
                }
              }
            }

            if (String(msgErroTemperaturaAmbiente).length > 0) {
              const validationErrorsmsgErroTemperaturaAmbiente = {
                temperaturanftbdescarganf: msgErroTemperaturaAmbiente,
              };
              if (formRef) {
                if (formRef.current) {
                  formRef.current.setErrors(
                    validationErrorsmsgErroTemperaturaAmbiente
                  );
                }
              }
            }
          }

          return valor;
        } catch (err) {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        } finally {
        }
      } else {
      }
    },
    []
  );

  // Calcula a volume 20 compartimento
  const handleGetVolumePara20Graus = React.useCallback(
    async (
      densidadeamostra20,
      temperaturaamostra,
      volumeambiente,
      calculodensidadeproduto
    ) => {
      if (
        densidadeamostra20 > 0 &&
        temperaturaamostra > 0 &&
        volumeambiente > 0 &&
        calculodensidadeproduto > 0
      ) {
        try {
          const { data } = await api.get(
            `/calculodensidades/converteVolumePara20Graus/${densidadeamostra20}/${temperaturaamostra}/${volumeambiente}/${calculodensidadeproduto}`
          );

          const valor = Number(data.volume20).toFixed(1);

          return valor;
        } catch (err) {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        } finally {
        }
      } else {
      }
    },
    []
  );

  useEffect(() => {
    if (compartimentos)
      handleChangeVolumeDeclaradoCompartimentos(compartimentos);
  }, [densidadecalculadaamostra20, calculodensidadeproduto]);

  const handleChangeVolumeDeclaradoCompartimentos = React.useCallback(
    async (compartimentos) => {
      let listaDeCompartimentosAux = [];

      listaDeCompartimentosAux = Object.assign([], compartimentos);

      for (let idx = 0; idx < listaDeCompartimentosAux.length; idx++) {
        if (
          listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento >
          0 &&
          listaDeCompartimentosAux[idx].volumedeclaradodescarganfcompartimento >
          0
        ) {
          const valor20 = await handleGetVolumePara20Graus(
            densidadecalculadaamostra20,
            listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento,
            listaDeCompartimentosAux[idx]
              .volumedeclaradodescarganfcompartimento,
            calculodensidadeproduto
          );

          listaDeCompartimentosAux[
            idx
          ].volume20descarganfcompartimento = Number(valor20);
        } else {
          listaDeCompartimentosAux[idx].volume20descarganfcompartimento = 0;
        }
        handleAtualizaCompartimentos(listaDeCompartimentosAux);
      }
    },
    [densidadecalculadaamostra20, calculodensidadeproduto]
  );

  const handleChangeVolume20NF = React.useCallback(async () => {
    // console.log(densidade20NF);
    // console.log(temperaturaNF);
    // console.log(volume);
    // console.log(calculodensidadeproduto);

    if (
      densidade20NF > 0 &&
      temperaturaNF > 0 &&
      volume > 0 &&
      !isUndefined(calculodensidadeproduto)
    ) {
      let valor20 = await handleGetVolumeNFPara20Graus(
        densidade20NF,
        temperaturaNF,
        volume,
        calculodensidadeproduto
      );

      if (isNull(valor20)) {
        valor20 = 0.0;
      }

      setInitials((state) => ({
        ...state,
        volume20nftbdescarganf: Number(valor20),
      }));

      setVolume20(Number(valor20));

      if (formRef.current) {
        await formRef.current.setFieldValue(
          'volume20nftbdescarganf',
          Number(valor20)
        );
      }
    } else if (formRef.current) {
      // console.log('setFieldValue volume20nftbdescarganf);')
      formRef.current.setFieldValue('volume20nftbdescarganf', '0.0');
      setVolume20(0);
      setInitials((state) => ({
        ...state,
        volume20nftbdescarganf: 0.0,
      }));
    }
  }, [densidade20NF, temperaturaNF, volume, calculodensidadeproduto]);

  const handleLimpaVolume20NF = React.useCallback(async () => {
    if (formRef.current) {
      await formRef.current.setFieldValue('volume20nftbdescarganf', '0.0');
    }
  }, []);

  useEffect(() => {
    // console.log('handleChangeVolume20NF')
    handleChangeVolume20NF();
  }, [densidade20NF, temperaturaNF, volume, calculodensidadeproduto]);

  useEffect(() => {
    handleGetConverteDensidadePara20Graus();
  }, [temperaturaamostra, densidadeamostra, calculodensidadeproduto]);

  // ******
  // ******
  // validar dagno 2025 nfe
  /*
   'naoLeuNF',
   'leuUmaNF',
   'leuMaisDeUmaNF',
   'leuNFManual',
 */
  useEffect(() => {
    // if (((!isEmpty(nfdescarganf)) && (statusLeituraNF === 'leuUmaNF'))
    //   || (statusLeituraNF === 'leuNFManual')) {
    if (!isEmpty(nfdescarganf) && statusLeituraNF === 'leuNFManual') {
      setLeuNF(true);
    }

    // if ((!isEmpty(nfdescarganf)) && (statusLeituraNF === 'leuNFManual')) {
    //   setLeuNF(true);
    // } else {
    //   setLeuNF(false);
    // }
  }, [nfdescarganf, statusLeituraNF]);

  const handleCloseAceitaSemNotaFiscal = React.useCallback(
    () => setOpenAceitaSemNotaFiscal(false),
    []
  );

  const handleConfirmaAceitaSemNotaFiscal = React.useCallback(async () => {
    setStatusLeituraNF('leuNFManual');
    handleCloseAceitaSemNotaFiscal();
  }, []);

  const nfeHeading = useMemo(
    () => [
      {
        id: 'nfnfe',
        label: t('s.operacao.notafiscalrecebida.nfnfe'),
        filter: { type: 'text' },
      },
      {
        id: 'idprodutonscastr',
        label: t('s.operacao.notafiscalrecebida.idprodutonscastr'),
        filter: { type: 'text' },
      },
      {
        id: 'cnpjdistribuidoranfe',
        label: t('s.operacao.notafiscalrecebida.cnpjdistribuidoranfe'),
        filter: { type: 'text' },
      },
      {
        id: 'qcomnfe',
        label: t('s.operacao.notafiscalrecebida.qcomnfe'),
        align: 'right',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'emissaonfe',
        label: t('s.operacao.notafiscalrecebida.emissaonfe'),
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
    ],
    []
  );

  const handleInputAceitaSemNotaFiscal = useCallback(
    async (value) => {
      // console.log('handleInputAceitaSemNotaFiscal');
      if (value) {
        if (!isEmpty(cnpjPosto) && cnpjPosto !== '0') {
          await handleVerificarNFEOutroDestinatario(String(value));

          // setNfdescarganf(value);
          // setOpenAceitaSemNotaFiscal(true)
          // await formRef.current.setFieldValue('nfdescarganf', value);
        } else {
          toast.error('O cnpj do posto é obrigatorio!');
        }
      }
    },
    [cnpjPosto]
  );

  const handleInputLimpoNotaFiscal = useCallback(() => {
    setNfdescarganf('');
    setStatusLeituraNF('');
    // setStatusLeituraNF('naoLeuNF');
    setCalculodensidadeproduto(0);
    // setHabCompartments(false);

    setVolume(0);
    setPrice(0);
    // console.log('handleInputLimpoNotaFiscal');

    setLeuNF(false);
    // console.log('handleInputLimpoNotaFiscal');
  }, []);

  const handlePostoCnpj = useCallback(async (value) => {
    // console.log('handlePostoCnpj');
    let cnpj = '';
    setNfdescarganf('');
    // setNfdescarganf(null);
    setStatusLeituraNF('');
    setLeuNF(false);
    setDesabilitaClearInputAtive(true);
    if (!isUndefined(value) && !isEmpty(value)) {
      cnpj = removerMascaraCNPJ(value);
    } else {
      cnpj = '0';
    }
    setCnpjPosto(cnpj);
  }, []);

  const handleallbackDesabilitaClearInputAtive = useCallback(async () => {
    // console.log('handleallbackDesabilitaClearInputAtive');
    setDesabilitaClearInputAtive(false);
  }, []);

  const handleInputNotaFiscal = useCallback((value) => {
    // console.log('handleInputNotaFiscal');
    if (value) {
      setStatusLeituraNF('leuUmaNF');
      setNfdescarganf(String(value.nfnfe));
      setObjNf(value);
      setIdnfedescarganf(value.idnfe);
      setVolume(Number(value?.qcomnfe));
      setPrice(Number(value?.vuncomnfe));

      formRef.current.setFieldValue('placactdescarganf', value.veictranspnfe);
      formRef.current.setFieldValue(
        'cnpjdistribuidoradescarganf',
        value.cnpjdistribuidoranfe
      );
      formRef.current.setFieldValue(
        'volumenfdescarganf',
        Number(value?.qcomnfe)
      );
      formRef.current.setFieldValue(
        'precounitariodescarganf',
        Number(value?.vuncomnfe)
      );
      formRef.current.setFieldValue(
        'cnpjtransportadoradescarganf',
        value?.cnpjtransportadoranfe
      );
      formRef.current.setFieldValue('idproduto', value?.idproduto);
      formRef.current.setFieldValue(
        'emissaonfe',
        moment(value?.emissaonfe).format('DD/MM/YYYY HH:mm')
      );

      if (
        !isUndefined(value?.calculodensidadeproduto) &&
        value?.calculodensidadeproduto > 0
      ) {
        setCalculodensidadeproduto(value?.calculodensidadeproduto);
      } else {
        setCalculodensidadeproduto(value?.calculodensidadeproduto);
        handleLimpaVolume20NF();
      }

      setLeuNF(true);
    } else {
      setNfdescarganf('');
      setStatusLeituraNF('naoLeuNF');
      setIdnfedescarganf('');
    }
  }, []);

  useEffect(() => {
    if (leuNF) {
      formRef.current.setFieldValue('placactdescarganf', objNf?.veictranspnfe);
      formRef.current.setFieldValue(
        'cnpjdistribuidoradescarganf',
        objNf?.cnpjdistribuidoranfe
      );
      formRef.current.setFieldValue(
        'volumenfdescarganf',
        Number(objNf?.qcomnfe)
      );
      formRef.current.setFieldValue(
        'precounitariodescarganf',
        Number(objNf?.vuncomnfe)
      );
      // formRef.current.setFieldValue('cnpjtransportadoradescarganf', objNf?.vprodnfe);
      formRef.current.setFieldValue(
        'cnpjtransportadoradescarganf',
        objNf?.cnpjtransportadoranfe
      );
      formRef.current.setFieldValue('idproduto', objNf?.idproduto);
      formRef.current.setFieldValue(
        'dataemissaonfdescarganf',
        moment(objNf?.emissaonfe).format('DD/MM/YYYY HH:mm')
      );

      setVolume(Number(objNf?.qcomnfe));
      setPrice(Number(objNf?.vuncomnfe));

      if (
        !isUndefined(objNf?.calculodensidadeproduto) &&
        objNf?.calculodensidadeproduto > 0
      ) {
        setCalculodensidadeproduto(objNf?.calculodensidadeproduto);
      } else {
        setCalculodensidadeproduto(objNf?.calculodensidadeproduto);
        handleLimpaVolume20NF();
      }
    }
  }, [objNf, leuNF]);

  const handleVerificarNFEOutroDestinatario = React.useCallback(
    async (nfnfe) => {
      try {
        const { data } = await api.get(
          `notafiscalrecebida/verificarnfeoutrodestinatario/${nfnfe}`
        );

        // console.log(JSON.stringify(data));

        if (data.statusnfe !== 'L') {
          toast.error(
            `Nfe está em uso! Verificar em Nota Fical Recebida`
            // `Nfe está em uso por outro detinatário! ${data.destinatario.nomedestinatarionfe}`
          );
        }

        if (data.destinatario.nomedestinatarionfe) {
          toast.error(
            `Nfe é de outro detinatário! ${data.destinatario.nomedestinatarionfe}`
          );
        } else {
          setNfdescarganf(nfnfe);
          setOpenAceitaSemNotaFiscal(true);
          await formRef.current.setFieldValue('nfdescarganf', nfnfe);
        }
      } catch (err) {
        setNfdescarganf(nfnfe);
        setOpenAceitaSemNotaFiscal(true);
        await formRef.current.setFieldValue('nfdescarganf', nfnfe);
      } finally {
      }
    },
    []
  );

  useEffect(() => {
    if (statusLeituraNF === 'leuNFManual') {
      setVersion('version5');
    } else if (statusLeituraNF === 'leuUmaNF') {
      setVersion('version5');
      // setVersion('version6')
    } else if (can(MODULONFE) && controlanfeclienteconfig === 'S') {
      setVersion('version5');
    } else {
      setVersion('version4');
    }
  }, [statusLeituraNF, controlanfeclienteconfig, MODULONFE]);

  // http://10.10.40.60:8080/scaplus/
  /*
  useEffect(() => {
    if (can(MODULOFOTO)) {
      if (!isFinalizado) {
        if (habHabilitafotonotafiscalposto) {
          if (iddescarganfgeral && idpostogeral) {
            if (tokenws) {
              let baseURL = sessionStorage.getItem('URL_BACKEND')
                ? sessionStorage.getItem('URL_BACKEND')
                : process.env.REACT_APP_URL_REQUEST;

  // useEffect(() => {
  //   if (can(MODULOFOTO)) {
  //     if (!isFinalizado) {
  //       if (habHabilitafotonotafiscalposto) {
  //         if (iddescarganfgeral && idpostogeral) {
  //           if (tokenws) {
  //             let baseURL = sessionStorage.getItem('URL_BACKEND')
  //               ? sessionStorage.getItem('URL_BACKEND')
  //               : process.env.REACT_APP_URL_REQUEST;

  //             if (!baseURL.endsWith('/')) {
  //               baseURL += '/';
  //             }

  //             let newUrl = baseURL.replace(/^http:\/\//i, 'ws://');

  //             newUrl = newUrl + 'geralwebsocket';

  //             const socket = new WebSocket(newUrl);

  //             socket.onopen = () => {
  //               // console.log("Conectado ao WebSocket");
  //               socket.send(tokenws);
  //             };

  //             socket.onmessage = (event) => {
  //               try {
  //                 // Fazer o parse do JSON recebido

  //                 setMessages(event.data);

  //                 const data = JSON.parse(event.data);

  //                 // Verificar o status e exibir a mensagem
  //                 if (data.status === 'ok') {
  //                   if (!isEmpty(formEdit)) {
  //                     const { iddescarganf, idposto } = formEdit;
  //                     // console.log(" socket.onmessage");
  //                     handleGetEditForm(iddescarganf, idposto);
  //                     handleGetDadosFotos(iddescarganf, idposto);
  //                   }

  //                   console.log('✅ Sucesso:', data.message);
  //                 } else {
  //                   console.error('❌ Erro:', data.message);
  //                 }
  //               } catch (error) {
  //                 console.error('❌ Erro ao processar JSON:', error);
  //               }

  //             };

  //             socket.onerror = (error) => {
  //               console.error('Erro na conexão WebSocket', error);
  //             };

  //             socket.onclose = () => {
  //               console.log('Conexão WebSocket fechada');
  //             };

              socket.onerror = (error) => {
                console.error('Erro na conexão WebSocket', error);
              };

              socket.onclose = () => {
                console.log('Conexão WebSocket fechada');
              };

              setWs(socket);
              return () => socket.close();
            }
          }
        }
      }
    }
  }, [
    tokenws,
    iddescarganfgeral,
    idpostogeral,
    controlanfeclienteconfig,
    formEdit,
    habHabilitafotonotafiscalposto,
    isFinalizado,
    MODULOFOTO,
  ]);
  */

  // }, [tokenws, formEdit, controlanfeclienteconfig ]);

  const sendMessage = () => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(message);
      setMessage('');
    }
  };

  if (loading) return <></>;
  return (
    <>
      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleFechaAlertaDivergenciaEstoque}
        aria-labelledby="alerta-divergencia-estoque-title"
        open={openAlertaDivergenciaEstoque}
      >
        <DialogTitle id="alerta-divergencia-estoque-title">ALERTA</DialogTitle>
        <DialogContent dividers>
          <Typography>
            VOLUME INFORMADO NO{tanquesDivergentesEstoque.length > 1 ? 'S TANQUES ' : ' TANQUE '}
            {tanquesDivergentesEstoque.join(', ')} ESTA DIVERGENTE DO ESTOQUE
            CONTABIL. DESEJA PROSSEGUIR?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmaAlertaDivergenciaEstoque}
            color="primary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.sim')}
          </Button>
          <Button
            onClick={handleFechaAlertaDivergenciaEstoque}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        open={open}
        fullScreen={window.innerWidth <= 450 ? window.innerWidth <= 450 : false}
        maxWidth={window.innerWidth <= 450 ? 0 <= 450 : 'xl'}
        // maxWidth="xl"
        onExit={handleCallbackClose}
      >
        <DialogTitle>{t('s.menu.operacao.recebimento')}</DialogTitle>

        {/* {JSON.stringify(receivement)} */}
        {/* {JSON.stringify(permitirselecionarmaisdeumtanquenorecebimentoclienteconfig)}
        {JSON.stringify(permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig)}
        {JSON.stringify(permitirrecebimentosemumxmlnosistemaclienteconfig)} */}

        <DialogContent>
          <FormUI
            ref={formRef}
            // initialData={isEmpty(formEdit) ? {} : initials}
            initialData={isEmpty(formEdit) ? {} : initials}
            onSubmit={handleSubmit}
          >
            <Accordion
              expanded={expanded === 'nf'}
              onChange={() => handleChangeAccordion('nf')}
            >
              <AccordionSummary
                expandIcon={receivement !== 2 && <ExpandMore />}
              >
                <Typography>
                  {t('s.operacao.recebimentonf.dadosdanf')}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <S.AccordionDetailsNF>
                  {/* <S.WrapperNF applyMargin={true} version={statusLeituraNF === 'leuUmaNF' ? 'version6' : 'version4'}> */}

                  <S.WrapperNF applyMargin version={version}>
                    <Autocomplete
                      name="idposto"
                      label="codigonomeposto"
                      url="postos"
                      unique="idposto"
                      title={t('s.configuracao.arqueacao.idposto')}
                      hiddens={[{ name: 'tipodescargaposto' }]}
                      disabled={isFinalizado || receivement === 1}
                      getValue={({
                        tipodescargaposto,
                        operrecebimento20posto,
                        controla20grausposto,
                        opercompartimentosposto,
                        habilitafotonotafiscalposto,
                        habilitainspesaodescargaposto,
                        cnpjposto,
                        operamostracompartimentossemreceb20posto,
                        habilitaskidposto,
                      }) => {
                        // handlePostoCnpj(cnpjposto);

                        setTypeTank(tipodescargaposto);

                        setHabReceipt(
                          operrecebimento20posto === 1 ||
                          operamostracompartimentossemreceb20posto === 1
                        );
                        // setHabReceipt(operrecebimento20posto === 1);

                        setHabOper20(
                          operrecebimento20posto === 1 &&
                          controla20grausposto === 1
                        );
                        setHabCompartments(opercompartimentosposto === 1);

                        setOperamostracompartimentossemreceb20(
                          operamostracompartimentossemreceb20posto === 1
                        );

                        setHabHabilitafotonotafiscalposto(
                          habilitafotonotafiscalposto === 'S'
                        );

                        setHabilitaInspesaoDescargaPosto(
                          habilitainspesaodescargaposto === 'S'
                        );

                        setStatusHabilitaSkidPosto(habilitaskidposto === 'S');

                        /** */

                        if (
                          can(MODULONFE) &&
                          controlanfeclienteconfig === 'S'
                        ) {
                          if (receivement !== 1) {
                            setCalculodensidadeproduto(0);
                            setVolume(0);
                            setPrice(0);
                            // console.log('codigonomeposto')
                          }

                          setNfdescarganf('');
                          setStatusLeituraNF('');
                          setLeuNF(false);
                          setDesabilitaClearInputAtive(true);
                          if (!isUndefined(cnpjposto) && !isEmpty(cnpjposto)) {
                            const cnpj = removerMascaraCNPJ(cnpjposto);
                            setCnpjPosto(cnpj);
                          } else {
                            setCnpjPosto('0');
                          }
                          setIdnfedescarganf('');
                        }
                      }}
                    />

                    {/* <Input
                      name="nfdescarganf"
                      label={t('s.operacao.recebimentonf.nfdescarganf')}
                      onKeyUp={({ key }) =>
                        key === 'Enter' && handleBuscaNotaFiscal()
                      }
                    /> */}

                    {/* //05-05-2025  novo para visualizar */}

                    {/* {JSON.stringify(receivement)} */}

                    {!isFinalizado &&
                      can(MODULONFE) &&
                      controlanfeclienteconfig === 'S' &&
                      receivement === 2 && (
                        <PesquisaTabelaInput
                          name="nfdescarganf"
                          userSelectFilterCountMaisQueUm
                          // onRow={(value) => console.log(JSON.stringify(value))}
                          onCallbackNaoEncotrado={(value) =>
                            handleInputAceitaSemNotaFiscal(value)
                          }
                          onCallbackConfirmado={(value) =>
                            handleInputNotaFiscal(value)
                          }
                          onCallbackCampoLimpo={() =>
                            handleInputLimpoNotaFiscal()
                          }
                          onCallbackDesabilitaClearInputAtive={() =>
                            handleallbackDesabilitaClearInputAtive()
                          }
                          label={t('s.operacao.recebimentonf.nfdescarganf')}
                          primary="nfnfe"
                          url="notafiscalrecebida/disponivel"
                          header={nfeHeading}
                          // getValue={(value) => setObjNf(value)}

                          disabledDigitacao={
                            !(
                              permitirrecebimentosemumxmlnosistemaclienteconfig ===
                              'S'
                            )
                          }
                          filterByUser
                          desabilitaPesquisaInput={
                            statusLeituraNF === 'leuNFManual'
                          }
                          desabilitaClearInputAtive={desabilitaClearInputAtive}
                          query={{
                            wherefield: ['cnpjdestinatarionfe'],
                            typewherefield: ['EQUALS'],
                            valuewherefield: [cnpjPosto],
                            pesquisalista: ['true'],
                          }}
                        />
                      )}

                    {!isFinalizado &&
                      can(MODULONFE) &&
                      controlanfeclienteconfig === 'S' && (
                        <>
                          {leuNF && receivement !== 2 && (
                            <>
                              {/* {JSON.stringify('araui')} */}
                              {/* <Hidden name='nfdescarganf' key='nfdescarganf' value={nfdescarganf} /> */}
                              <Input
                                name="nfdescarganf"
                                label={t(
                                  's.operacao.recebimentonf.nfdescarganf'
                                )}
                                disabled
                                value={nfdescarganf}
                              />
                            </>
                          )}

                          {!leuNF && receivement !== 2 && (
                            // <Hidden name='nfdescarganf' key='nfdescarganf' />
                            <Input
                              name="nfdescarganf"
                              label={t('s.operacao.recebimentonf.nfdescarganf')}
                              disabled
                            />
                          )}
                        </>
                      )}

                    {(isFinalizado ||
                      !can(MODULONFE) ||
                      controlanfeclienteconfig === 'N') && (
                        <Input
                          name="nfdescarganf"
                          label={t('s.operacao.recebimentonf.nfdescarganf')}
                          disabled={isFinalizado}
                        />
                      )}

                    {/* {JSON.stringify(leuNF)} */}

                    {/* 05-05-2025  novo para visualizar */}
                    {/* {!isFinalizado && ( */}

                    {(!can(MODULONFE) ||
                      controlanfeclienteconfig === 'N' ||
                      isFinalizado ||
                      leuNF ||
                      (receivement === 1 && statusRecebimento === 1) ||
                      (receivement === 1 && statusRecebimento === 2)) && (
                        <>
                          {/* {JSON.stringify('pasou aqui')} */}

                          {/* {(controlanfeclienteconfig === 'S') &&
                          <>

                            {leuNF &&
                              <Hidden name='nfdescarganf' key='nfdescarganf' value={nfdescarganf} />
                            }

                            {!leuNF &&
                              // <Hidden name='nfdescarganf' key='nfdescarganf' />
                              <Input
                                name="nfdescarganf"
                                label={t('s.operacao.recebimentonf.nfdescarganf')}
                                disabled
                              />
                            }
                          </>}

                        {(controlanfeclienteconfig === 'N') &&
                          <Input
                            name="nfdescarganf"
                            label={t('s.operacao.recebimentonf.nfdescarganf')}
                          />
                        } */}

                          {statusLeituraNF !== 'leuUmaNF' && (
                            <Autocomplete
                              name="idproduto"
                              label="nomeproduto"
                              url="produtos"
                              unique="idproduto"
                              title={t('s.menu.configuracao.produto')}
                              disabled={isFinalizado || receivement === 1}
                              getValue={({ calculodensidadeproduto }) => {
                                if (
                                  !isUndefined(calculodensidadeproduto) &&
                                  calculodensidadeproduto > 0
                                ) {
                                  // console.log('Autocomplete calculodensidadeproduto')
                                  // console.log(calculodensidadeproduto)
                                  setCalculodensidadeproduto(
                                    calculodensidadeproduto
                                  );
                                } else {
                                  // console.log('Autocomplete calculodensidadeproduto')
                                  // console.log(calculodensidadeproduto)
                                  setCalculodensidadeproduto(
                                    calculodensidadeproduto
                                  );
                                  handleLimpaVolume20NF();
                                }
                              }}
                            // defaultValue={idnfedescarganf !== '' ? objNf.idprodutocliente : initials.idproduto}
                            />
                          )}

                          {statusLeituraNF === 'leuUmaNF' && (
                            <>
                              {/* <Hidden name='idproduto' key='idproduto' value={objNf?.idproduto} /> */}
                              {/* <TextField */}
                              <Input
                                name="idproduto"
                                variant="outlined"
                                size="small"
                                label={t('s.menu.configuracao.produto')}
                                value={objNf?.nomeproduto}
                                disabled
                              />
                            </>
                          )}

                          <Input
                            name="numeropedidodescarganf"
                            disabled={isFinalizado}
                            label={t(
                              's.operacao.recebimentonf.numeropedidodescarganf'
                            )}
                          />

                          <Input
                            name="placactdescarganf"
                            label={t(
                              's.operacao.recebimentonf.placactdescarganf'
                            )}
                            disabled={isFinalizado}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? objNf.veictranspnfe
                                : initials.placactdescarganf
                            }
                          // disabled={
                          //   (statusLeituraNF === 'leuUmaNF' || initials.comnfedescarganf === 'S')
                          // }
                          />

                          <Input
                            name="motoristadescarganf"
                            disabled={isFinalizado}
                            label={t(
                              's.operacao.recebimentonf.motoristadescarganf'
                            )}
                          />

                          {statusLeituraNF !== 'leuUmaNF' && (
                            <Autocomplete
                              name="cnpjdistribuidoradescarganf"
                              label="cnpjnomedistribuidoranfe"
                              url="distribuidorasnfes"
                              unique="cnpjdistribuidoranfe"
                              title={t(
                                's.operacao.recebimentonf.cnpjdistribuidoradescarganf'
                              )}
                              disabled={
                                isFinalizado ||
                                statusLeituraNF === 'leuUmaNF' ||
                                initials.comnfedescarganf === 'S'
                              }
                            />
                          )}

                          {statusLeituraNF === 'leuUmaNF' && (
                            <Input
                              name="cnpjdistribuidoradescarganf"
                              label={t(
                                's.operacao.recebimentonf.cnpjdistribuidoradescarganf'
                              )}
                              defaultValue={
                                idnfedescarganf !== ''
                                  ? objNf.cnpjdistribuidoranfe
                                  : initials.cnpjdistribuidoradescarganf
                              }
                              disabled={
                                isFinalizado ||
                                statusLeituraNF === 'leuUmaNF' ||
                                initials.comnfedescarganf === 'S'
                              }
                            />
                          )}

                          {statusLeituraNF !== 'leuUmaNF' && (
                            <Autocomplete
                              name="cnpjtransportadoradescarganf"
                              label="cnpjnometransportadoranfe"
                              url="transportadorasnfes"
                              unique="cnpjtransportadoranfe"
                              title={t(
                                's.operacao.recebimentonf.cnpjtransportadoradescarganf'
                              )}
                              disabled={
                                isFinalizado ||
                                statusLeituraNF === 'leuUmaNF' ||
                                initials.comnfedescarganf === 'S'
                              }
                            />
                          )}

                          {statusLeituraNF === 'leuUmaNF' && (
                            <Input
                              name="cnpjtransportadoradescarganf"
                              label={t(
                                's.operacao.recebimentonf.cnpjtransportadoradescarganf'
                              )}
                              defaultValue={
                                idnfedescarganf !== ''
                                  ? objNf.cnpjtransportadoranfe
                                  : initials.cnpjtransportadoradescarganf
                              }
                              disabled={
                                isFinalizado ||
                                statusLeituraNF === 'leuUmaNF' ||
                                initials.comnfedescarganf === 'S'
                              }
                            />
                          )}

                          {statusLeituraNF !== 'leuUmaNF' && (
                            <DateTime
                              name="dataemissaonfdescarganf"
                              label={t(
                                's.operacao.recebimentonf.dataemissaonfdescarganf'
                              )}
                              disabled={
                                isFinalizado || initials.comnfedescarganf === 'S'
                              }
                            />
                          )}

                          {isFinalizado ||
                            (statusLeituraNF === 'leuUmaNF' && (
                              <Input
                                name="dataemissaonfdescarganf"
                                value={moment(objNf?.emissaonfe).format(
                                  'DD/MM/YYYY'
                                )}
                                label={t(
                                  's.operacao.recebimentonf.dataemissaonfdescarganf'
                                )}
                                disabled
                              />
                            ))}

                          <Input
                            name="volumenfdescarganf"
                            label={t(
                              's.operacao.recebimentonf.volumenfdescarganf'
                            )}
                            type="number"
                            getValue={(value) => setVolume(Number(value))}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? Number(objNf.qcomnfe)
                                : Number(initials.volumenfdescarganf)
                            }
                            disabled={
                              isFinalizado ||
                              statusLeituraNF === 'leuUmaNF' ||
                              initials.comnfedescarganf === 'S'
                            }
                          />

                          <Input
                            name="precounitariodescarganf"
                            label={t(
                              's.operacao.recebimentonf.precounitariodescarganf'
                            )}
                            type="number"
                            getValue={(value) => setPrice(Number(value))}
                            defaultValue={
                              idnfedescarganf !== ''
                                ? Number(objNf.vuncomnfe)
                                : Number(initials.precounitariodescarganf)
                            }
                            disabled={
                              isFinalizado ||
                              statusLeituraNF === 'leuUmaNF' ||
                              initials.comnfedescarganf === 'S'
                            }
                          />

                          <Input
                            disabled
                            name="precototaldescarganf"
                            label={t(
                              's.operacao.recebimentonf.precototaldescarganf'
                            )}
                            value={number(total, 2)}
                          />
                        </>
                      )}

                    {can(CUSTOMIZACAO_RAIZEN) && (
                      <Select
                        name="tipodescarganf"
                        label={t('s.cadastro.veiculo.tipoveiculo')}
                        options={[
                          { value: '1', label: 'Não DCM' },
                          { value: '2', label: 'DCM' },
                        ]}
                        disabled={isFinalizado}
                      />
                    )}
                  </S.WrapperNF>

                  <S.WrapperNF>
                    {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                      <>
                        <Input
                          disabled={isFinalizado || !habOper20}
                          name="densidade20nftbdescarganf"
                          type="number"
                          label={t(
                            's.operacao.recebimento.densidade20nftbdescarganf'
                          )}
                          getValue={(value) => {
                            // if (value < 2) {
                            setDensidade20NF(Number(value));
                            // } else {
                            //  setDensidade20NF(0)
                            // }
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;

                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                              // return true;
                            } else {
                              if (
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 189 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              // if (Number(event.target.value) > 2) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   setVolume20(0);
                              //   return false;
                              // }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                            } else {
                              // if (Number(event.target.value) > 2) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   setVolume20(0);
                              //   return false;
                              // }
                            }
                          }}
                        />

                        <Input
                          disabled={isFinalizado || !habOper20}
                          type="number"
                          name="temperaturanftbdescarganf"
                          label={t(
                            's.operacao.recebimento.temperaturanftbdescarganf'
                          )}
                          getValue={(value) => {
                            // if (Number(value) < 99) {
                            setTemperaturaNF(Number(value));
                            // } else {
                            //  setTemperaturaNF(0)
                            // }
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              //
                              if (
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 189 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              /* const valor = String(event.target.value);
                                if (valor !== '') {
                                  if (Number(event.target.value) > 99) {
                                    event.preventDefault();
                                    //event.target.value = '0';
                                    return false;
                                  }
                                }
                                */
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              /*
                              const valor = String(event.target.value);
                              if (valor !== '') {
                                if (Number(event.target.value) > 99) {
                                  event.preventDefault();
                                  //event.target.value = '0';
                                  return false;
                                }
                              }
                              */
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                            }
                          }}
                        />

                        <Input
                          disabled
                          name="volume20nftbdescarganf"
                          label={t(
                            's.operacao.recebimento.volume20nftbdescarganf'
                          )}
                          value={number(volume20, 0)}
                          getValue={(value) => setVolume20(Number(value))}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                        />
                      </>
                    )}

                    {habCompartments && can(SKID) && (
                      <Hidden name="numerocompartimentosdescarganf" value="1" />
                    )}
                    {habCompartments && !can(SKID) && (
                      <Input
                        disabled={
                          isFinalizado || !habCompartments || receivement === 1
                        }
                        name="numerocompartimentosdescarganf"
                        type="number"
                        label={t('s.operacao.recebimento.numerocompartimentos')}
                        getValue={(value) =>
                          setNumberCompartments(Number(value))
                        }
                      // onBlur={() => setNecessarioBtnSalvar(true)}
                      />
                    )}
                    {/*
                    {habCompartments && permitirselecionarmaisdeumcompartimentonorecebimentoclienteconfig === "N" && (
                      <>
                        <Input
                          disabled={isFinalizado || !habCompartments || receivement === 1}
                          name="numerocompartimentosdescarganf"
                          type="number"
                          label={t(
                            's.operacao.recebimento.numerocompartimentos'
                          )}
                          getValue={(value) => {
                             setNumberCompartments(Number1)
                          }
                        // onBlur={() => setNecessarioBtnSalvar(true)}
                        />
                      </>
                    )} */}
                  </S.WrapperNF>

                  <S.WrapperNF>
                    {((receivement === 2 &&
                      statusRecebimento === RECEBIMENTO_READ_ONLY) ||
                      (receivement === 1 &&
                        statusRecebimento === RECEBIMENTO_SELECT_TANKS)) && (
                        <DateTime
                          nullable
                          time
                          name="datahorainiciodescarganf"
                          label={t(
                            's.operacao.recebimentonf.datahorainiciodescarganf'
                          )}
                          value={
                            isEmpty(initials.datahorainiciodescarganf)
                              ? null
                              : moment(
                                initials.datahorainiciodescarganf,
                                'DD/MM/YYYY HH:mm:ss'
                              )
                          }
                          disabled={habilitaDtaCampoInicio !== true}
                          getValue={(value) =>
                            setInitials((state) => ({
                              ...state,
                              datahorainiciodescarganf: value,
                            }))
                          }
                        />
                      )}

                    {receivement === 1 &&
                      statusRecebimento === RECEBIMENTO_WAIT_FINISH && (
                        <Input
                          name="datahorainiciodescarganf"
                          value={initials.datahorainiciodescarganf}
                          label={t(
                            's.operacao.recebimentonf.datahorainiciodescarganf'
                          )}
                          disabled
                        />
                      )}

                    {receivement === 1 &&
                      statusRecebimento === RECEBIMENTO_WAIT_FINISH && (
                        <DateTime
                          nullable
                          time
                          name="datahorafimdescarganf"
                          label={t(
                            's.operacao.recebimentonf.datahorafimdescarganf'
                          )}
                          disabled={
                            !(
                              (typeTank === 1 &&
                                statusRecebimento !==
                                RECEBIMENTO_WAIT_FINISH) ||
                              habilitaDtaCampoFim === true
                            )
                          }
                          getValue={(value) =>
                            setInitials((state) => ({
                              ...state,
                              datahorafimdescarganf: value,
                            }))
                          }
                        />
                      )}

                    {!isFinalizado && typeTank === 2 && (
                      <DateTime
                        nullable
                        time
                        name="datahorafimdescarganf"
                        label={t(
                          's.operacao.recebimentonf.datahorafimdescarganf'
                        )}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            datahorafimdescarganf: value,
                          }))
                        }
                      />
                    )}

                    {/* //05-05-2025  novo para visualizar */}
                    {isFinalizado && (
                      <>
                        <Input
                          name="datahorainiciodescarganf"
                          value={initials.datahorainiciodescarganf}
                          label={t(
                            's.operacao.recebimentonf.datahorainiciodescarganf'
                          )}
                          disabled
                        />
                        <Input
                          name="datahorafimdescarganf"
                          value={initials.datahorafimdescarganf}
                          label={t(
                            's.operacao.recebimentonf.datahorafimdescarganf'
                          )}
                          disabled
                        />
                      </>
                    )}
                  </S.WrapperNF>

                  {/* <pre>{JSON.stringify({ habOper20, calculodensidadeproduto, habCompartments, compartimentos, tanques, initials }, null, 2)}</pre> */}
                </S.AccordionDetailsNF>
              </AccordionDetails>
            </Accordion>

            {receivement === 1 &&
              habReceipt &&
              habCompartments &&
              Number(calculodensidadeproduto) >= 1 && (
                <Accordion
                  expanded={expanded === 'sample'}
                  onChange={() => handleChangeAccordion('sample')}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>
                      {t('s.operacao.recebimentonf.sample')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <S.Wrapper>
                      <S.WrapperGroupSample>
                        <Input
                          disabled={isFinalizado}
                          // disabled={isFinalizado || !habOper20}
                          name="compartimentoamostradescarganf"
                          type="number"
                          getValue={(value) =>
                            setInitials((state) => ({
                              ...state,
                              compartimentoamostradescarganf: Number(value),
                            }))
                          }
                          InputProps={{
                            inputProps: {
                              pattern: '[0-9]*',
                              maxLength: 2,
                              max: 16,
                              min: 1,
                            },
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;

                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              if (
                                charCode === 110 ||
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 188 ||
                                charCode === 189 ||
                                charCode === 190 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              if (Number(event.target.value) > 16) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };
                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              if (
                                Number(event.target.value) > numberCompartments
                              ) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };

                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              const validationErrors = {
                                ...formRef.current.getErrors(),
                                compartimentoamostradescarganf: '',
                              };
                              if (formRef) {
                                if (formRef.current) {
                                  formRef.current.setErrors(validationErrors);
                                }
                              }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;

                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              if (Number(event.target.value) > 16) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  ...formRef.current.getErrors(),
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };
                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              if (
                                Number(event.target.value) > numberCompartments
                              ) {
                                event.preventDefault();
                                event.target.value = '';
                                const validationErrors = {
                                  ...formRef.current.getErrors(),
                                  compartimentoamostradescarganf: `Valor máxima permitido ${numberCompartments}`,
                                };
                                if (formRef) {
                                  if (formRef.current) {
                                    formRef.current.setErrors(validationErrors);
                                  }
                                }
                                return false;
                              }
                              const validationErrors = {
                                ...formRef.current.getErrors(),
                                compartimentoamostradescarganf: '',
                              };
                              if (formRef) {
                                if (formRef.current) {
                                  formRef.current.setErrors(validationErrors);
                                }
                              }
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                            }
                          }}
                          label={t(
                            's.operacao.recebimento.compartimentoamostratbdescarganf'
                          )}
                        />

                        <Input
                          disabled={isFinalizado}
                          // disabled={isFinalizado || !habOper20}
                          name="temperaturaamostratbdescarganf"
                          getValue={(value) => {
                            setTemperaturaamostra(Number(value));

                            setInitials((state) => ({
                              ...state,
                              temperaturaamostratbdescarganf: Number(value),
                            }));
                          }}
                          // getValue={
                          //   (value) => setTemperaturaamostra(Number(value))
                          // }

                          type="number"
                          label={t(
                            's.operacao.recebimento.temperaturaamostratbdescarganf'
                          )}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              if (
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 189 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              // if (Number(event.target.value) > 99) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                            } else {
                              // if (Number(event.target.value) > 99) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                            }
                          }}
                        />

                        <Input
                          disabled={isFinalizado}
                          // disabled={isFinalizado || !habOper20}
                          name="densidadeambienteamostratbdescarganf"
                          type="number"
                          label={t(
                            's.operacao.recebimento.densidadeambienteamostratbdescarganf'
                          )}
                          // getValue={(value) => setDensidadeamostra(Number(value))}

                          getValue={(value) => {
                            setDensidadeamostra(Number(value));

                            setInitials((state) => ({
                              ...state,
                              densidadeambienteamostratbdescarganf: Number(
                                value
                              ),
                            }));
                          }}
                          onBlur={() => setNecessarioBtnSalvar(true)}
                          onKeyDown={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                              // return true;
                            } else {
                              if (
                                charCode === 109 ||
                                charCode === 107 ||
                                charCode === 189 ||
                                charCode === 16
                              ) {
                                event.preventDefault();
                                event.target.value = '0';
                                return false;
                              }
                              // if (Number(event.target.value) > 2) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                          }}
                          onKeyUp={(event) => {
                            const charCode = event.which
                              ? event.which
                              : event.keyCode;
                            if (
                              charCode === 8 ||
                              (charCode >= 46 && charCode <= 57)
                            ) {
                              // console.log(event.target.value);
                              // return true;
                            } else {
                              // if (Number(event.target.value) > 2) {
                              //   event.preventDefault();
                              //   event.target.value = '0';
                              //   return false;
                              // }
                            }
                            if (event.key === 'Enter') {
                              // console.log(event.target.value);
                              // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                            }
                          }}
                        />

                        <Input
                          disabled
                          name="densidade20amostradescarganf"
                          style={{ backgroundColor: '#dcdcdc' }}
                          label={t(
                            's.operacao.recebimento.densidade20amostratbdescarganf'
                          )}
                          value={
                            densidadecalculadaamostra20 > 0
                              ? densidadecalculadaamostra20
                              : ''
                          }
                        />
                      </S.WrapperGroupSample>
                    </S.Wrapper>
                  </AccordionDetails>
                </Accordion>
              )}

            {receivement === 1 && habCompartments && (
              <Accordion
                expanded={expanded === 'compartments'}
                onChange={() => handleChangeAccordion('compartments')}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                    {t('s.operacao.recebimentonf.compartments')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableCompartments
                    isFinalizado={isFinalizado}
                    idposto={initials.idposto}
                    idproduto={initials.idproduto}
                    status={statusRecebimento}
                    listaDeCompartimentos={compartimentos}
                    constrolsAt20={habReceipt}
                    densidadecalculadaamostra20={densidadecalculadaamostra20}
                    calculodensidadeproduto={calculodensidadeproduto}
                    onAtualizaCompartimentos={handleAtualizaCompartimentos}
                    onUpdateStatus={() =>
                      handleGetSummaryVL(
                        initials.iddescarganf,
                        initials.idposto
                      )
                    }
                  />
                </AccordionDetails>
              </Accordion>
            )}

            {receivement === 1 && (
              <Accordion
                expanded={expanded === 'tank'}
                onChange={() => handleChangeAccordion('tank')}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                    {t('s.operacao.recebimentonf.tanques')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TabelaRecebimento
                    idposto={initials.idposto}
                    idproduto={initials.idproduto}
                    status={statusRecebimento}
                    listaDeTanques={tanques}
                    onAtualizaTanques={handleAtualizaTanques}
                    onUpdateStatus={() =>
                      handleGetSummaryVL(
                        initials.iddescarganf,
                        initials.idposto
                      )
                    }
                    permitirselecionarmaisdeumtanque={
                      permitirselecionarmaisdeumtanquenorecebimentoclienteconfig
                    }
                  />
                </AccordionDetails>
              </Accordion>
            )}

            {/* ---------- */}

            {receivement === 1 &&
              habHabilitafotonotafiscalposto &&
              can(MODULOFOTO) && (
                <Accordion
                  expanded={expanded === 'photo'}
                  onChange={() => handleChangeAccordion('photo')}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>
                      {t('s.operacao.notafiscalrecebida.photo')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <S.AccordionDetailsNF>
                      {/* ({JSON.stringify(jatiroufotodescarganf)}) */}

                      {/* <button onClick={irParaFotoNF}>Abrir Foto NF</button> */}

                      {!isFinalizado && jatiroufotodescarganf !== 'S' && (
                        <>
                          {isMobile && (
                            <ButtonBase
                              onClick={() => irParaFotoNF()}
                              style={{
                                borderRadius: 8,
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                transition: 'transform 0.1s, box-shadow 0.1s',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                width: '200px',
                                marginBottom: '16px', // Espaço entre os botões
                              }}
                              onMouseDown={(e) =>
                              (e.currentTarget.style.transform =
                                'scale(0.95)')
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                            >
                              <Typography variant="body2" color="primary">
                                Abrir Foto NF
                              </Typography>
                            </ButtonBase>
                          )}

                          <QRCode
                            style={{
                              height: 'auto',
                              maxWidth: '270px',
                              width: '100%',
                            }}
                            // value={`${window.location.host}/fotonf?id=${initials?.tokenuuiddescarganf}&token=${JSON.stringify(token?.token).replace(/^["']|["']$/g, '')}`}
                            value={`${appUrl}`}
                            viewBox="0 0 50 50"
                          // viewBox="0 0 256 256"
                          />
                        </>
                      )}

                      {jatiroufotodescarganf === 'S' && (
                        <S.WrapperNFFoto>
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            gap={2} // Espaço entre os botões
                            p={2} // Padding interno do container
                          >
                            {/* {JSON.stringify(dataFotos)} */}

                            <ButtonBase
                              onClick={() =>
                                window.open(
                                  dataFotos?.urlfotofrentefotodescarganf,
                                  '_blank',
                                  'noopener,noreferrer'
                                )
                              }
                              style={{
                                borderRadius: 8,
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                transition: 'transform 0.1s, box-shadow 0.1s',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                width: '200px',
                                marginBottom: '16px', // Espaço entre os botões
                              }}
                              onMouseDown={(e) =>
                              (e.currentTarget.style.transform =
                                'scale(0.95)')
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                            >
                              <Typography variant="body2" color="primary">
                                Foto Frente
                              </Typography>
                            </ButtonBase>

                            <ButtonBase
                              onClick={() =>
                                window.open(
                                  dataFotos?.urlfotoversofotodescarganf,
                                  '_blank',
                                  'noopener,noreferrer'
                                )
                              }
                              style={{
                                borderRadius: 8,
                                padding: '8px 16px',
                                backgroundColor: '#f0f0f0',
                                transition: 'transform 0.1s, box-shadow 0.1s',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                width: '200px',
                                marginBottom: '16px', // Espaço entre os botões
                              }}
                              onMouseDown={(e) =>
                              (e.currentTarget.style.transform =
                                'scale(0.95)')
                              }
                              onMouseUp={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = 'scale(1)')
                              }
                            >
                              <Typography variant="body2" color="primary">
                                Foto Verso
                              </Typography>
                            </ButtonBase>

                            {!isFinalizado && (
                              <DeleteButtonWithModal
                                onDelete={() =>
                                  handleDeleteFotos(
                                    dataFotos?.iddescarganf,
                                    dataFotos?.idposto
                                  )
                                }
                                disabled={loading}
                              />
                            )}
                          </Box>

                          {/* <S.WrapperNFFotoimagens> */}
                          <Typography variant="body2" color="primary">
                            Foto Frente
                            <img
                              src={dataFotos?.urlfotofrentefotodescarganf}
                              alt="Imagem do banco de dados"
                              style={{
                                width: '300px',
                                height: '300px',
                                marginRight: '16px',
                              }}
                            />
                          </Typography>
                          <Typography variant="body2" color="primary">
                            Foto Verso
                            <img
                              src={dataFotos?.urlfotoversofotodescarganf}
                              alt="Imagem do banco de dados"
                              style={{ width: '300px', height: '300px' }}
                            />
                          </Typography>
                          {/* </S.WrapperNFFotoimagens> */}
                        </S.WrapperNFFoto>
                      )}
                    </S.AccordionDetailsNF>
                  </AccordionDetails>
                </Accordion>
              )}

            {receivement === 1 && habilitaInspesaoDescargaPosto && (
              <Accordion
                expanded={expanded === 'Inspection'}
                onChange={() => handleChangeAccordion('Inspection')}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>
                    {t('s.operacao.notafiscalrecebida.Inspection')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <S.Wrapper> */}
                  {/* <S.WrapperGroupInspection> */}
                  <S.AccordionDetailsNF>
                    <S.WrapperNF applyMargin version="version4">
                      <DateTime
                        time
                        nullable
                        disableFuture
                        name="inspecao.inpsdataentradabdescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsdataentradabdescarganfinspecao'
                        )}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsdataentradabdescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      {/* {JSON.stringify(initials)} */}

                      <DateTime
                        time
                        nullable
                        disableFuture
                        name="inspecao.inpsdatasaidabdescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsdatasaidabdescarganfinspecao'
                        )}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsdatasaidabdescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      <Select
                        name="inspecao.inpslacresconferemdescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpslacresconferemdescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpslacresconferemdescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      {initials?.inspecao
                        ?.inpslacresconferemdescarganfinspecao === 'S' && (
                          <Input
                            name="inspecao.inpslacresnumerodescarganfinspecao"
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 249 }}
                            label={t(
                              's.operacao.notafiscalrecebida.inspecao.inpslacresnumerodescarganfinspecao'
                            )}
                            getValue={(value) =>
                              setInitials((state) => ({
                                ...state,
                                inspecao: {
                                  ...(state.inspecao || {}),
                                  inpslacresnumerodescarganfinspecao: value,
                                },
                              }))
                            }
                            disabled={isFinalizado}
                          />
                        )}

                      {/* <Input
                        name="inspecao.inpslacresnumerodescarganfinspecao"
                        variant="outlined"
                        size="small"
                        label={t('s.operacao.notafiscalrecebida.inspecao.inpslacresnumerodescarganfinspecao')}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpslacresnumerodescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      /> */}

                      <Select
                        name="inspecao.inspprodutosetadescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inspprodutosetadescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inspprodutosetadescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      <Select
                        name="inspecao.inpsisentoaguaimpurezadescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsisentoaguaimpurezadescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsisentoaguaimpurezadescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />

                      <Select
                        name="inspecao.inpsvisualprodutodescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpsvisualprodutodescarganfinspecao'
                        )}
                        options={[
                          { value: 'OK', label: t('s.geral.opcoes.ok') },
                          { value: 'NOK', label: t('s.geral.opcoes.nok') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpsvisualprodutodescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />
                      <Select
                        name="inspecao.inpscompartimentovaziodescarganfinspecao"
                        label={t(
                          's.operacao.notafiscalrecebida.inspecao.inpscompartimentovaziodescarganfinspecao'
                        )}
                        options={[
                          { value: 'N', label: t('s.geral.opcoes.nao') },
                          { value: 'S', label: t('s.geral.opcoes.sim') },
                        ]}
                        getValue={(value) =>
                          setInitials((state) => ({
                            ...state,
                            inspecao: {
                              ...(state.inspecao || {}),
                              inpscompartimentovaziodescarganfinspecao: value,
                            },
                          }))
                        }
                        disabled={isFinalizado}
                      />
                    </S.WrapperNF>
                  </S.AccordionDetailsNF>
                  {/* </S.Wrapper> */}
                </AccordionDetails>
              </Accordion>
            )}

            {includes(
              [RECEBIMENTO_WAIT_FINISH, RECEBIMENTO_READ_ONLY],
              statusRecebimento
            ) &&
              receivement === 1 &&
              habReceipt &&
              habOper20 &&
              Number(calculodensidadeproduto) >= 1 && (
                <Accordion
                  expanded={expanded === 'batch'}
                  onChange={() => handleChangeAccordion('batch')}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>
                      {t('s.operacao.recebimentonf.batch')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <TableBatch
                      idposto={initials.idposto}
                      idproduto={initials.idproduto}
                      status={statusRecebimento}
                      listaDeTanques={tanques}
                      constrolsAt20={habReceipt}
                      calculodensidadeproduto={calculodensidadeproduto}
                      onAtualizaTanques={handleAtualizaTanques}
                      onUpdateStatus={() =>
                        handleGetSummaryVL(
                          initials.iddescarganf,
                          initials.idposto
                        )
                      }
                      isFinalizado={isFinalizado}
                    />
                  </AccordionDetails>
                </Accordion>
              )}
          </FormUI>

          {includes(
            [RECEBIMENTO_WAIT_FINISH, RECEBIMENTO_READ_ONLY],
            statusRecebimento
          ) && (
              <S.WrapperSummary>
                <Typography>
                  {t('s.operacao.recebimentonf.resumovolumerecebido')}
                </Typography>

                <S.WrapperGroupInputs>
                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.volumenfdescarganf')}
                    value={number(initials.volumenfdescarganf || volume, 0)}
                    size="small"
                    variant="outlined"
                  />

                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.volumerec')}
                    value={number(tanquesVolumeRec, 0)}
                    size="small"
                    variant="outlined"
                  />

                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.volAbastecido')}
                    value={number(resumoVolAbs, 0)}
                    size="small"
                    variant="outlined"
                  />

                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.difnf')}
                    value={number(
                      tanquesVolumeRec +
                      resumoVolAbs -
                      (initials.volumenfdescarganf || volume),
                      0
                    )}
                    size="small"
                    variant="outlined"
                  />

                  {receivement === 1 && habCompartments && (
                    <TextField
                      disabled
                      fullWidth
                      label={t('Vol. Rec. Compartimentos')}
                      value={number(compartimentosVolumeRec, 0)}
                      size="small"
                      variant="outlined"
                    />
                  )}

                  {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                    <>
                      <TextField
                        disabled
                        fullWidth
                        label={t('Volume 20 NF')}
                        value={number(volume20, 0)}
                        size="small"
                        variant="outlined"
                      />

                      {habCompartments && (
                        <TextField
                          disabled
                          fullWidth
                          label={t('Vol. 20 Rec. Compartimentos')}
                          value={number(compartimentosVolume20Rec, 0)}
                          size="small"
                          variant="outlined"
                        />
                      )}

                      {habCompartments && (
                        <TextField
                          disabled
                          fullWidth
                          label={t('Dif 20 (NF - Med Comp.)')}
                          value={number(volume20 - compartimentosVolume20Rec, 0)}
                          size="small"
                          variant="outlined"
                        />
                      )}
                    </>
                  )}

                  {can(SKID) && statusHabilitaSkidPosto === true && (
                    <>
                      <TextField
                        disabled
                        fullWidth
                        label={t('s.operacao.recebimentonf.skid.volumerecskid')}
                        value={number(volumeSkid, 0)}
                        size="small"
                        variant="outlined"
                      />
                      <TextField
                        disabled
                        fullWidth
                        label={t('s.operacao.recebimentonf.skid.difnfskid')}
                        value={number(
                          volumeSkid - initials.volumenfdescarganf,
                          0
                        )}
                        size="small"
                        variant="outlined"
                      />
                      {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                        <TextField
                          disabled
                          fullWidth
                          label={t(
                            's.operacao.recebimentonf.skid.volume20recskid'
                          )}
                          value={number(volume20Skid, 0)}
                          size="small"
                          variant="outlined"
                        />
                      )}
                      <TextField
                        disabled
                        fullWidth
                        label={t('s.operacao.recebimentonf.skid.temperatura')}
                        value={number(temperaturaSkid, 1)}
                        size="small"
                        variant="outlined"
                      />
                      <TextField
                        disabled
                        fullWidth
                        label={t('s.operacao.recebimentonf.skid.densidade')}
                        value={number(densidadeSkid, 4)}
                        size="small"
                        variant="outlined"
                      />
                    </>
                  )}
                </S.WrapperGroupInputs>
              </S.WrapperSummary>
            )}
        </DialogContent>
        <DialogActions>
          {/* 05-05-2025  novo para visualizar */}
          {!isFinalizado && (
            <Button
              onClick={() => formRef.current.submitForm()}
              color="primary"
              variant="outlined"
              disabled={load}
            >
              {t('s.geral.botaosalvar')}
            </Button>
          )}

          {receivement === 1 && statusRecebimento === RECEBIMENTO_SELECT_TANKS && (
            <Button
              onClick={() => {
                handleValidaCapturaInicio(tanques);
              }}
              color="primary"
              variant="outlined"
              disabled={load}
            >
              {t('s.geral.botaoconfirmarinicio')}
            </Button>
          )}

          {receivement === 1 && statusRecebimento === RECEBIMENTO_WAIT_FINISH && (
            <Button
              onClick={() => {
                handleValidaCapturaFim(tanques);
              }}
              color="primary"
              variant="outlined"
              disabled={load}
            >
              {t('s.geral.botaoconfirmarfim')}
            </Button>
          )}

          <Button onClick={closeModal} color="secondary" variant="outlined">
            {t('s.geral.botaofechar')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleFechaAlertaCapacidade}
        aria-labelledby="alerta-capacidade-title"
        open={openAlertaCapacidade}
      >
        <DialogTitle id="alerta-capacidade-title">ALERTA</DialogTitle>
        <DialogContent dividers>
          <Typography>
            NÃO HÁ ESPAÇO SUFICIENTE NOS TANQUES SELECIONADOS PARA RECEBER O
            VOLUME DESSA DESCARGA. DESEJA CONTINUAR?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmaAlertaCapacidade}
            color="primary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.sim')}
          </Button>
          <Button
            onClick={handleFechaAlertaCapacidade}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleFechaJustificativaCapacidade}
        aria-labelledby="justificativa-capacidade-title"
        open={openJustificativaCapacidade}
      >
        <DialogTitle id="justificativa-capacidade-title">
          Justificativa obrigatória
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Informe a justificativa para prosseguir com o inicio da descarga.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={4}
            label="Justificativa"
            value={justificativaCapacidade}
            onChange={(event) => setJustificativaCapacidade(event.target.value)}
            error={
              justificativaCapacidade.length > LIMITE_JUSTIFICATIVA_CAPACIDADE
            }
            helperText={
              justificativaCapacidade.length > LIMITE_JUSTIFICATIVA_CAPACIDADE
                ? `Limite de ${LIMITE_JUSTIFICATIVA_CAPACIDADE} caracteres excedido.`
                : `${justificativaCapacidade.length}/${LIMITE_JUSTIFICATIVA_CAPACIDADE} caracteres`
            }
            FormHelperTextProps={{
              style: {
                marginTop: 8,
              },
            }}
            disabled={load}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmaJustificativaCapacidade}
            color="primary"
            variant="outlined"
            disabled={
              load ||
              justificativaCapacidade.length > LIMITE_JUSTIFICATIVA_CAPACIDADE
            }
          >
            {t('s.geral.botaoconfirmar')}
          </Button>
          <Button
            onClick={handleFechaJustificativaCapacidade}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleCloseConfirmaInicio}
        aria-labelledby="customized-dialog-title"
        open={openConfirmaInicio}
      >
        <DialogTitle id="customized-dialog-title">
          {t('s.operacao.recebimentonf.confirmarinicio')}
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {t('s.operacao.recebimentonf.tanquesselecionados')}:
          </Typography>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{t('s.operacao.recebimentonf.tanque')}</TableCell>
                <TableCell align="right">
                  {t('s.operacao.recebimentonf.capacidade')}
                </TableCell>
                <TableCell align="right">
                  {t('s.operacao.recebimentonf.volatual')}
                </TableCell>
                <TableCell align="right">
                  {t('s.operacao.recebimentonf.espacovazio')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tanques.map(
                (tanque) =>
                  tanque.tanqueselecionado === 1 && (
                    <TableRow key={tanque.idtanquefisico}>
                      <TableCell component="th" scope="row">
                        {tanque.codigotanquefisico}
                      </TableCell>
                      <TableCell align="right">
                        {number(tanque.capacidadeoperacionaltanquefisico, 0)}
                      </TableCell>
                      <TableCell align="right">
                        {number(tanque.volumeinicialdescarganftanque, 0)}
                      </TableCell>
                      <TableCell align="right">
                        {number(
                          tanque.capacidadeoperacionaltanquefisico -
                          tanque.volumeinicialdescarganftanque,
                          0
                        )}
                      </TableCell>
                    </TableRow>
                  )
              )}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleConfirmaInicio}
            color="primary"
            variant="outlined"
            disabled={load}
          >
            {load ? 'SALVANDO...' : t('s.geral.opcoes.sim')}
          </Button>
          <Button
            onClick={handleCloseConfirmaInicio}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleCloseConfirmaFim}
        aria-labelledby="customized-dialog-title"
        open={openConfirmaFim}
      >
        <DialogTitle id="customized-dialog-title">
          {t('s.operacao.recebimentonf.confirmarfim')}
        </DialogTitle>
        <DialogContent dividers>
          <S.WrapperGroupFim red={diffNFMed > 0.6}>
            <S.WrapperFim>
              <S.WrapperIcon red={diffNFMed > 0.6}>
                {diffNFMed > 0.6 ? <ThumbDown /> : <ThumbUp />}
              </S.WrapperIcon>
              <S.WrapperInputs>
                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.volumenf')}
                  variant="outlined"
                  size="small"
                  value={number(initials.volumenfdescarganf, 0)}
                />

                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.volumemedido')}
                  variant="outlined"
                  size="small"
                  value={number(Number(tanquesVolumeRec + resumoVolAbs), 0)}
                />

                {can(SKID) && statusHabilitaSkidPosto === true && (
                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.skid.volumerecskid')}
                    value={number(volumeSkid, 0)}
                    size="small"
                    variant="outlined"
                  />
                )}

                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.skid.difnftanque')}
                  variant="outlined"
                  size="small"
                  value={number(
                    tanquesVolumeRec +
                    resumoVolAbs -
                    (initials.volumenfdescarganf || volume),
                    0
                  )}
                />

                {can(SKID) && statusHabilitaSkidPosto === true && (
                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.skid.difnfskid')}
                    value={number(volumeSkid - initials.volumenfdescarganf, 0)}
                    size="small"
                    variant="outlined"
                  />
                )}

                <TextField
                  disabled
                  fullWidth
                  label={t('s.operacao.recebimentonf.diferenca')}
                  variant="outlined"
                  size="small"
                  value={number(
                    tanquesVolumeRec +
                    resumoVolAbs -
                    (initials.volumenfdescarganf || volume),
                    0
                  )}
                />

                {receivement === 1 && habCompartments && (
                  <TextField
                    disabled
                    fullWidth
                    label={t('Volume Recebido Compartimentos')}
                    value={number(compartimentosVolumeRec, 0)}
                    size="small"
                    variant="outlined"
                  />
                )}

                {habOper20 && Number(calculodensidadeproduto) >= 1 && (
                  <>
                    <TextField
                      disabled
                      fullWidth
                      label={t('Volume 20 NF')}
                      value={number(volume20, 0)}
                      size="small"
                      variant="outlined"
                    />

                    {habCompartments && (
                      <TextField
                        disabled
                        fullWidth
                        label={t('Volume Recebido 20 Compartimentos')}
                        value={number(compartimentosVolume20Rec, 0)}
                        size="small"
                        variant="outlined"
                      />
                    )}

                    {habCompartments && (
                      <TextField
                        disabled
                        fullWidth
                        label={t('Dif 20 (NF - Med Comp.)')}
                        value={number(volume20 - compartimentosVolume20Rec, 0)}
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </>
                )}

                {can(SKID) && statusHabilitaSkidPosto === true && habOper20 && (
                  <TextField
                    disabled
                    fullWidth
                    label={t('s.operacao.recebimentonf.skid.volume20recskid')}
                    value={number(
                      initials?.resultadoDescargaSkid
                        ?.volume20descarganfrealizado,
                      0
                    )}
                    size="small"
                    variant="outlined"
                  />
                )}
              </S.WrapperInputs>
            </S.WrapperFim>

            {diffNFMed > 0.6 && (
              <Typography className="alerta">
                {t('s.operacao.recebimentonf.diferencaacimapermitido')}
              </Typography>
            )}
          </S.WrapperGroupFim>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleConfirmaFim}
            color="primary"
            variant="outlined"
            disabled={load}
          >
            {load ? 'SALVANDO...' : t('s.geral.opcoes.sim')}
          </Button>
          <Button
            onClick={handleCloseConfirmaFim}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal para verificar se aceita fazer o processo de recebimento sem a nota fiscal */}
      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        onClose={handleCloseAceitaSemNotaFiscal}
        aria-labelledby="customized-dialog-title"
        open={openAceitaSemNotaFiscal}
        fullScreen={window.innerWidth <= 450}
      >
        <DialogTitle id="customized-dialog-title">
          Aceita fazer o processo de recebimento sem a NFE(xml)
          {/* {t('s.operacao.recebimentonf.selecionarnotafiscal')} */}
        </DialogTitle>
        <DialogContent dividers>
          Confirma fazer o processo de recebimento sem a NFE(xml)?
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => handleConfirmaAceitaSemNotaFiscal()}
            color="primary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.sim')}
          </Button>
          <Button
            onClick={handleCloseAceitaSemNotaFiscal}
            color="secondary"
            variant="outlined"
            disabled={load}
          >
            {t('s.geral.opcoes.nao')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

Form.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  formEdit: PropTypes.objectOf(PropTypes.any),
};

Form.defaultProps = {
  formEdit: {},
};

export default Form;
